/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listResourceAggregateUserPermissions = /* GraphQL */ `query ListResourceAggregateUserPermissions(
  $resourceType: PermissionResourceType!
  $resourceId: String!
  $nextToken: String
) {
  listResourceAggregateUserPermissions(
    resourceType: $resourceType
    resourceId: $resourceId
    nextToken: $nextToken
  ) {
    items {
      userId
      username
      permissions
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceAggregateUserPermissionsQueryVariables,
  APITypes.ListResourceAggregateUserPermissionsQuery
>;
export const getAttachment = /* GraphQL */ `query GetAttachment($id: ID!) {
  getAttachment(id: $id) {
    id
    name
    type
    parentId
    parentType
    propertyId
    key
    localCreatedAtTime
    status
    imageSource
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAttachmentQueryVariables,
  APITypes.GetAttachmentQuery
>;
export const listAttachments = /* GraphQL */ `query ListAttachments(
  $id: ID
  $filter: ModelAttachmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAttachments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      type
      parentId
      parentType
      propertyId
      key
      localCreatedAtTime
      status
      imageSource
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAttachmentsQueryVariables,
  APITypes.ListAttachmentsQuery
>;
export const syncAttachments = /* GraphQL */ `query SyncAttachments(
  $filter: ModelAttachmentFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAttachments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      type
      parentId
      parentType
      propertyId
      key
      localCreatedAtTime
      status
      imageSource
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAttachmentsQueryVariables,
  APITypes.SyncAttachmentsQuery
>;
export const listAttachmentsByParent = /* GraphQL */ `query ListAttachmentsByParent(
  $parentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAttachmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAttachmentsByParent(
    parentId: $parentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      type
      parentId
      parentType
      propertyId
      key
      localCreatedAtTime
      status
      imageSource
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAttachmentsByParentQueryVariables,
  APITypes.ListAttachmentsByParentQuery
>;
export const listAttachmentsByProperty = /* GraphQL */ `query ListAttachmentsByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAttachmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAttachmentsByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      type
      parentId
      parentType
      propertyId
      key
      localCreatedAtTime
      status
      imageSource
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAttachmentsByPropertyQueryVariables,
  APITypes.ListAttachmentsByPropertyQuery
>;
export const getBiddingContact = /* GraphQL */ `query GetBiddingContact($id: ID!) {
  getBiddingContact(id: $id) {
    id
    email
    ownerEntityId
    contactEntityId
    name
    privateDescription
    publicDescription
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBiddingContactQueryVariables,
  APITypes.GetBiddingContactQuery
>;
export const listBiddingContacts = /* GraphQL */ `query ListBiddingContacts(
  $id: ID
  $filter: ModelBiddingContactFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBiddingContacts(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      email
      ownerEntityId
      contactEntityId
      name
      privateDescription
      publicDescription
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBiddingContactsQueryVariables,
  APITypes.ListBiddingContactsQuery
>;
export const syncBiddingContacts = /* GraphQL */ `query SyncBiddingContacts(
  $filter: ModelBiddingContactFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncBiddingContacts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      email
      ownerEntityId
      contactEntityId
      name
      privateDescription
      publicDescription
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBiddingContactsQueryVariables,
  APITypes.SyncBiddingContactsQuery
>;
export const listBiddingContactsByOwnerEntityId = /* GraphQL */ `query ListBiddingContactsByOwnerEntityId(
  $ownerEntityId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelBiddingContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listBiddingContactsByOwnerEntityId(
    ownerEntityId: $ownerEntityId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      ownerEntityId
      contactEntityId
      name
      privateDescription
      publicDescription
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBiddingContactsByOwnerEntityIdQueryVariables,
  APITypes.ListBiddingContactsByOwnerEntityIdQuery
>;
export const getBidInvitation = /* GraphQL */ `query GetBidInvitation($id: ID!) {
  getBidInvitation(id: $id) {
    id
    biddingContactId
    tenderId
    ownerEntityId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBidInvitationQueryVariables,
  APITypes.GetBidInvitationQuery
>;
export const listBidInvitations = /* GraphQL */ `query ListBidInvitations(
  $id: ID
  $filter: ModelBidInvitationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBidInvitations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      biddingContactId
      tenderId
      ownerEntityId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBidInvitationsQueryVariables,
  APITypes.ListBidInvitationsQuery
>;
export const syncBidInvitations = /* GraphQL */ `query SyncBidInvitations(
  $filter: ModelBidInvitationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncBidInvitations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      biddingContactId
      tenderId
      ownerEntityId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBidInvitationsQueryVariables,
  APITypes.SyncBidInvitationsQuery
>;
export const listBidInvitationsByTenderId = /* GraphQL */ `query ListBidInvitationsByTenderId(
  $tenderId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelBidInvitationFilterInput
  $limit: Int
  $nextToken: String
) {
  listBidInvitationsByTenderId(
    tenderId: $tenderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      biddingContactId
      tenderId
      ownerEntityId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBidInvitationsByTenderIdQueryVariables,
  APITypes.ListBidInvitationsByTenderIdQuery
>;
export const getBid = /* GraphQL */ `query GetBid($id: ID!) {
  getBid(id: $id) {
    id
    tenderId
    latestMinorVersion
    latestAcceptedMinorVersion
    latestSubmittedMinorVersion
    status
    bidNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetBidQueryVariables, APITypes.GetBidQuery>;
export const listBids = /* GraphQL */ `query ListBids(
  $id: ID
  $filter: ModelBidFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBids(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      tenderId
      latestMinorVersion
      latestAcceptedMinorVersion
      latestSubmittedMinorVersion
      status
      bidNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListBidsQueryVariables, APITypes.ListBidsQuery>;
export const syncBids = /* GraphQL */ `query SyncBids(
  $filter: ModelBidFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncBids(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      tenderId
      latestMinorVersion
      latestAcceptedMinorVersion
      latestSubmittedMinorVersion
      status
      bidNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncBidsQueryVariables, APITypes.SyncBidsQuery>;
export const listBidsByTenderId = /* GraphQL */ `query ListBidsByTenderId(
  $tenderId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelBidFilterInput
  $limit: Int
  $nextToken: String
) {
  listBidsByTenderId(
    tenderId: $tenderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenderId
      latestMinorVersion
      latestAcceptedMinorVersion
      latestSubmittedMinorVersion
      status
      bidNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBidsByTenderIdQueryVariables,
  APITypes.ListBidsByTenderIdQuery
>;
export const listBidsByCreatedBy = /* GraphQL */ `query ListBidsByCreatedBy(
  $createdBy: String!
  $sortDirection: ModelSortDirection
  $filter: ModelBidFilterInput
  $limit: Int
  $nextToken: String
) {
  listBidsByCreatedBy(
    createdBy: $createdBy
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenderId
      latestMinorVersion
      latestAcceptedMinorVersion
      latestSubmittedMinorVersion
      status
      bidNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBidsByCreatedByQueryVariables,
  APITypes.ListBidsByCreatedByQuery
>;
export const getBidMinorVersion = /* GraphQL */ `query GetBidMinorVersion($id: ID!) {
  getBidMinorVersion(id: $id) {
    id
    bidId
    minorVersion
    tenderId
    tenderMinorVersion
    proposalId
    status
    metadata {
      bidderContactName
      bidderContactEmail
      bidderCompanyName
      bidderContactAddress
      bidderContactPhoneNumber
      bidderWebsite
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBidMinorVersionQueryVariables,
  APITypes.GetBidMinorVersionQuery
>;
export const listBidMinorVersions = /* GraphQL */ `query ListBidMinorVersions(
  $id: ID
  $filter: ModelBidMinorVersionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBidMinorVersions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      bidId
      minorVersion
      tenderId
      tenderMinorVersion
      proposalId
      status
      metadata {
        bidderContactName
        bidderContactEmail
        bidderCompanyName
        bidderContactAddress
        bidderContactPhoneNumber
        bidderWebsite
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBidMinorVersionsQueryVariables,
  APITypes.ListBidMinorVersionsQuery
>;
export const syncBidMinorVersions = /* GraphQL */ `query SyncBidMinorVersions(
  $filter: ModelBidMinorVersionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncBidMinorVersions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      bidId
      minorVersion
      tenderId
      tenderMinorVersion
      proposalId
      status
      metadata {
        bidderContactName
        bidderContactEmail
        bidderCompanyName
        bidderContactAddress
        bidderContactPhoneNumber
        bidderWebsite
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBidMinorVersionsQueryVariables,
  APITypes.SyncBidMinorVersionsQuery
>;
export const listBidMinorVersionsByBidId = /* GraphQL */ `query ListBidMinorVersionsByBidId(
  $bidId: String!
  $minorVersion: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelBidMinorVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  listBidMinorVersionsByBidId(
    bidId: $bidId
    minorVersion: $minorVersion
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      bidId
      minorVersion
      tenderId
      tenderMinorVersion
      proposalId
      status
      metadata {
        bidderContactName
        bidderContactEmail
        bidderCompanyName
        bidderContactAddress
        bidderContactPhoneNumber
        bidderWebsite
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBidMinorVersionsByBidIdQueryVariables,
  APITypes.ListBidMinorVersionsByBidIdQuery
>;
export const getClientLog = /* GraphQL */ `query GetClientLog($id: ID!) {
  getClientLog(id: $id) {
    id
    userId
    userAgent
    severityLevel
    componentName
    message
    details
    tags
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClientLogQueryVariables,
  APITypes.GetClientLogQuery
>;
export const listClientLogs = /* GraphQL */ `query ListClientLogs(
  $id: ID
  $filter: ModelClientLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listClientLogs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userId
      userAgent
      severityLevel
      componentName
      message
      details
      tags
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientLogsQueryVariables,
  APITypes.ListClientLogsQuery
>;
export const syncClientLogs = /* GraphQL */ `query SyncClientLogs(
  $filter: ModelClientLogFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncClientLogs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userId
      userAgent
      severityLevel
      componentName
      message
      details
      tags
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncClientLogsQueryVariables,
  APITypes.SyncClientLogsQuery
>;
export const listClientLogsByUserId = /* GraphQL */ `query ListClientLogsByUserId(
  $userId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelClientLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listClientLogsByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      userAgent
      severityLevel
      componentName
      message
      details
      tags
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientLogsByUserIdQueryVariables,
  APITypes.ListClientLogsByUserIdQuery
>;
export const getCounter = /* GraphQL */ `query GetCounter($id: ID!) {
  getCounter(id: $id) {
    id
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCounterQueryVariables,
  APITypes.GetCounterQuery
>;
export const listCounters = /* GraphQL */ `query ListCounters(
  $filter: ModelCounterFilterInput
  $limit: Int
  $nextToken: String
) {
  listCounters(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCountersQueryVariables,
  APITypes.ListCountersQuery
>;
export const syncCounters = /* GraphQL */ `query SyncCounters(
  $filter: ModelCounterFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCounters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCountersQueryVariables,
  APITypes.SyncCountersQuery
>;
export const getDesignDocument = /* GraphQL */ `query GetDesignDocument($id: ID!) {
  getDesignDocument(id: $id) {
    id
    designDocumentGroupId
    propertyId
    projectId
    name
    status
    lastEvaluatedValidityStatus
    uploadStatus
    documentKey
    lastWorkScopeSpecificationItemNumber
    version
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDesignDocumentQueryVariables,
  APITypes.GetDesignDocumentQuery
>;
export const listDesignDocuments = /* GraphQL */ `query ListDesignDocuments(
  $id: ID
  $filter: ModelDesignDocumentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDesignDocuments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      designDocumentGroupId
      propertyId
      projectId
      name
      status
      lastEvaluatedValidityStatus
      uploadStatus
      documentKey
      lastWorkScopeSpecificationItemNumber
      version
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDesignDocumentsQueryVariables,
  APITypes.ListDesignDocumentsQuery
>;
export const syncDesignDocuments = /* GraphQL */ `query SyncDesignDocuments(
  $filter: ModelDesignDocumentFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDesignDocuments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      designDocumentGroupId
      propertyId
      projectId
      name
      status
      lastEvaluatedValidityStatus
      uploadStatus
      documentKey
      lastWorkScopeSpecificationItemNumber
      version
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDesignDocumentsQueryVariables,
  APITypes.SyncDesignDocumentsQuery
>;
export const listDesignDocumentsByGroupByVersion = /* GraphQL */ `query ListDesignDocumentsByGroupByVersion(
  $designDocumentGroupId: ID!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDesignDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  listDesignDocumentsByGroupByVersion(
    designDocumentGroupId: $designDocumentGroupId
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      designDocumentGroupId
      propertyId
      projectId
      name
      status
      lastEvaluatedValidityStatus
      uploadStatus
      documentKey
      lastWorkScopeSpecificationItemNumber
      version
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDesignDocumentsByGroupByVersionQueryVariables,
  APITypes.ListDesignDocumentsByGroupByVersionQuery
>;
export const listDesignDocumentsByGroupByStatus = /* GraphQL */ `query ListDesignDocumentsByGroupByStatus(
  $designDocumentGroupId: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDesignDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  listDesignDocumentsByGroupByStatus(
    designDocumentGroupId: $designDocumentGroupId
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      designDocumentGroupId
      propertyId
      projectId
      name
      status
      lastEvaluatedValidityStatus
      uploadStatus
      documentKey
      lastWorkScopeSpecificationItemNumber
      version
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDesignDocumentsByGroupByStatusQueryVariables,
  APITypes.ListDesignDocumentsByGroupByStatusQuery
>;
export const listDesignDocumentsByProperty = /* GraphQL */ `query ListDesignDocumentsByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDesignDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  listDesignDocumentsByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      designDocumentGroupId
      propertyId
      projectId
      name
      status
      lastEvaluatedValidityStatus
      uploadStatus
      documentKey
      lastWorkScopeSpecificationItemNumber
      version
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDesignDocumentsByPropertyQueryVariables,
  APITypes.ListDesignDocumentsByPropertyQuery
>;
export const listDesignDocumentsByProject = /* GraphQL */ `query ListDesignDocumentsByProject(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDesignDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  listDesignDocumentsByProject(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      designDocumentGroupId
      propertyId
      projectId
      name
      status
      lastEvaluatedValidityStatus
      uploadStatus
      documentKey
      lastWorkScopeSpecificationItemNumber
      version
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDesignDocumentsByProjectQueryVariables,
  APITypes.ListDesignDocumentsByProjectQuery
>;
export const getDesignDocumentGroup = /* GraphQL */ `query GetDesignDocumentGroup($id: ID!) {
  getDesignDocumentGroup(id: $id) {
    id
    projectId
    propertyId
    name
    latestDocumentVersion
    documentContentKey
    solutionGroupNumber
    isLocked
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDesignDocumentGroupQueryVariables,
  APITypes.GetDesignDocumentGroupQuery
>;
export const listDesignDocumentGroups = /* GraphQL */ `query ListDesignDocumentGroups(
  $id: ID
  $filter: ModelDesignDocumentGroupFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDesignDocumentGroups(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      projectId
      propertyId
      name
      latestDocumentVersion
      documentContentKey
      solutionGroupNumber
      isLocked
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDesignDocumentGroupsQueryVariables,
  APITypes.ListDesignDocumentGroupsQuery
>;
export const syncDesignDocumentGroups = /* GraphQL */ `query SyncDesignDocumentGroups(
  $filter: ModelDesignDocumentGroupFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDesignDocumentGroups(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      projectId
      propertyId
      name
      latestDocumentVersion
      documentContentKey
      solutionGroupNumber
      isLocked
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDesignDocumentGroupsQueryVariables,
  APITypes.SyncDesignDocumentGroupsQuery
>;
export const listDesignDocumentGroupsByProject = /* GraphQL */ `query ListDesignDocumentGroupsByProject(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDesignDocumentGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listDesignDocumentGroupsByProject(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      propertyId
      name
      latestDocumentVersion
      documentContentKey
      solutionGroupNumber
      isLocked
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDesignDocumentGroupsByProjectQueryVariables,
  APITypes.ListDesignDocumentGroupsByProjectQuery
>;
export const listDesignDocumentGroupsByProperty = /* GraphQL */ `query ListDesignDocumentGroupsByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDesignDocumentGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listDesignDocumentGroupsByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      propertyId
      name
      latestDocumentVersion
      documentContentKey
      solutionGroupNumber
      isLocked
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDesignDocumentGroupsByPropertyQueryVariables,
  APITypes.ListDesignDocumentGroupsByPropertyQuery
>;
export const getDimension = /* GraphQL */ `query GetDimension($id: ID!) {
  getDimension(id: $id) {
    id
    parentId
    propertyId
    createdInSolution
    description
    length
    lengthUnit
    width
    widthUnit
    dimensionType
    measurementUnit
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDimensionQueryVariables,
  APITypes.GetDimensionQuery
>;
export const listDimensions = /* GraphQL */ `query ListDimensions(
  $id: ID
  $filter: ModelDimensionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDimensions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      parentId
      propertyId
      createdInSolution
      description
      length
      lengthUnit
      width
      widthUnit
      dimensionType
      measurementUnit
      measurement {
        length
        width
        dimensionType
        measurementUnit
        __typename
      }
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDimensionsQueryVariables,
  APITypes.ListDimensionsQuery
>;
export const syncDimensions = /* GraphQL */ `query SyncDimensions(
  $filter: ModelDimensionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDimensions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      parentId
      propertyId
      createdInSolution
      description
      length
      lengthUnit
      width
      widthUnit
      dimensionType
      measurementUnit
      measurement {
        length
        width
        dimensionType
        measurementUnit
        __typename
      }
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDimensionsQueryVariables,
  APITypes.SyncDimensionsQuery
>;
export const listDimensionsByParent = /* GraphQL */ `query ListDimensionsByParent(
  $parentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDimensionFilterInput
  $limit: Int
  $nextToken: String
) {
  listDimensionsByParent(
    parentId: $parentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      parentId
      propertyId
      createdInSolution
      description
      length
      lengthUnit
      width
      widthUnit
      dimensionType
      measurementUnit
      measurement {
        length
        width
        dimensionType
        measurementUnit
        __typename
      }
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDimensionsByParentQueryVariables,
  APITypes.ListDimensionsByParentQuery
>;
export const listDimensionsByProperty = /* GraphQL */ `query ListDimensionsByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDimensionFilterInput
  $limit: Int
  $nextToken: String
) {
  listDimensionsByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      parentId
      propertyId
      createdInSolution
      description
      length
      lengthUnit
      width
      widthUnit
      dimensionType
      measurementUnit
      measurement {
        length
        width
        dimensionType
        measurementUnit
        __typename
      }
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDimensionsByPropertyQueryVariables,
  APITypes.ListDimensionsByPropertyQuery
>;
export const getDiscoverableWorkTypes = /* GraphQL */ `query GetDiscoverableWorkTypes($id: ID!) {
  getDiscoverableWorkTypes(id: $id) {
    id
    workTypeGroupId
    defaultVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDiscoverableWorkTypesQueryVariables,
  APITypes.GetDiscoverableWorkTypesQuery
>;
export const listDiscoverableWorkTypes = /* GraphQL */ `query ListDiscoverableWorkTypes(
  $id: ID
  $filter: ModelDiscoverableWorkTypesFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDiscoverableWorkTypes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      workTypeGroupId
      defaultVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDiscoverableWorkTypesQueryVariables,
  APITypes.ListDiscoverableWorkTypesQuery
>;
export const syncDiscoverableWorkTypes = /* GraphQL */ `query SyncDiscoverableWorkTypes(
  $filter: ModelDiscoverableWorkTypesFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDiscoverableWorkTypes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      workTypeGroupId
      defaultVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDiscoverableWorkTypesQueryVariables,
  APITypes.SyncDiscoverableWorkTypesQuery
>;
export const getEntityResourcePermission = /* GraphQL */ `query GetEntityResourcePermission($id: ID!) {
  getEntityResourcePermission(id: $id) {
    id
    propertyId
    entityId
    entityType
    resourceId
    resourceType
    permissionType
    isGranted
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEntityResourcePermissionQueryVariables,
  APITypes.GetEntityResourcePermissionQuery
>;
export const listEntityResourcePermissions = /* GraphQL */ `query ListEntityResourcePermissions(
  $id: ID
  $filter: ModelEntityResourcePermissionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEntityResourcePermissions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      entityId
      entityType
      resourceId
      resourceType
      permissionType
      isGranted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEntityResourcePermissionsQueryVariables,
  APITypes.ListEntityResourcePermissionsQuery
>;
export const syncEntityResourcePermissions = /* GraphQL */ `query SyncEntityResourcePermissions(
  $filter: ModelEntityResourcePermissionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncEntityResourcePermissions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      entityId
      entityType
      resourceId
      resourceType
      permissionType
      isGranted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncEntityResourcePermissionsQueryVariables,
  APITypes.SyncEntityResourcePermissionsQuery
>;
export const listEntityResourcePermissionByEntityIdByResourceId = /* GraphQL */ `query ListEntityResourcePermissionByEntityIdByResourceId(
  $entityId: ID!
  $resourceId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEntityResourcePermissionFilterInput
  $limit: Int
  $nextToken: String
) {
  listEntityResourcePermissionByEntityIdByResourceId(
    entityId: $entityId
    resourceId: $resourceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      entityId
      entityType
      resourceId
      resourceType
      permissionType
      isGranted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEntityResourcePermissionByEntityIdByResourceIdQueryVariables,
  APITypes.ListEntityResourcePermissionByEntityIdByResourceIdQuery
>;
export const listEntityResourcePermissionByResourceId = /* GraphQL */ `query ListEntityResourcePermissionByResourceId(
  $resourceId: ID!
  $resourceType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEntityResourcePermissionFilterInput
  $limit: Int
  $nextToken: String
) {
  listEntityResourcePermissionByResourceId(
    resourceId: $resourceId
    resourceType: $resourceType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      entityId
      entityType
      resourceId
      resourceType
      permissionType
      isGranted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEntityResourcePermissionByResourceIdQueryVariables,
  APITypes.ListEntityResourcePermissionByResourceIdQuery
>;
export const getEntityWorkTypeAssociation = /* GraphQL */ `query GetEntityWorkTypeAssociation($id: ID!) {
  getEntityWorkTypeAssociation(id: $id) {
    id
    entityId
    entityType
    workTypeGroupId
    workTypeVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEntityWorkTypeAssociationQueryVariables,
  APITypes.GetEntityWorkTypeAssociationQuery
>;
export const listEntityWorkTypeAssociations = /* GraphQL */ `query ListEntityWorkTypeAssociations(
  $filter: ModelEntityWorkTypeAssociationFilterInput
  $limit: Int
  $nextToken: String
) {
  listEntityWorkTypeAssociations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      entityId
      entityType
      workTypeGroupId
      workTypeVersion
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEntityWorkTypeAssociationsQueryVariables,
  APITypes.ListEntityWorkTypeAssociationsQuery
>;
export const syncEntityWorkTypeAssociations = /* GraphQL */ `query SyncEntityWorkTypeAssociations(
  $filter: ModelEntityWorkTypeAssociationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncEntityWorkTypeAssociations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityId
      entityType
      workTypeGroupId
      workTypeVersion
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncEntityWorkTypeAssociationsQueryVariables,
  APITypes.SyncEntityWorkTypeAssociationsQuery
>;
export const listEntityWorkTypeAssociationsByEntityIdByWorkTypeGroupId = /* GraphQL */ `query ListEntityWorkTypeAssociationsByEntityIdByWorkTypeGroupId(
  $entityId: ID!
  $workTypeGroupId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEntityWorkTypeAssociationFilterInput
  $limit: Int
  $nextToken: String
) {
  listEntityWorkTypeAssociationsByEntityIdByWorkTypeGroupId(
    entityId: $entityId
    workTypeGroupId: $workTypeGroupId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      entityId
      entityType
      workTypeGroupId
      workTypeVersion
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEntityWorkTypeAssociationsByEntityIdByWorkTypeGroupIdQueryVariables,
  APITypes.ListEntityWorkTypeAssociationsByEntityIdByWorkTypeGroupIdQuery
>;
export const getInspection = /* GraphQL */ `query GetInspection($id: ID!) {
  getInspection(id: $id) {
    id
    propertyId
    createdByOrganizationId
    createdByUserId
    startTime
    endTime
    status
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInspectionQueryVariables,
  APITypes.GetInspectionQuery
>;
export const listInspections = /* GraphQL */ `query ListInspections(
  $id: ID
  $filter: ModelInspectionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listInspections(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      createdByOrganizationId
      createdByUserId
      startTime
      endTime
      status
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInspectionsQueryVariables,
  APITypes.ListInspectionsQuery
>;
export const syncInspections = /* GraphQL */ `query SyncInspections(
  $filter: ModelInspectionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncInspections(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      createdByOrganizationId
      createdByUserId
      startTime
      endTime
      status
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncInspectionsQueryVariables,
  APITypes.SyncInspectionsQuery
>;
export const getIssue = /* GraphQL */ `query GetIssue($id: ID!) {
  getIssue(id: $id) {
    id
    locationId
    propertyId
    inspectionId
    createdInSolution
    name
    description
    note
    tags
    tagIds
    status
    clientCreationDate
    localLastUpdatedTime
    createdBy
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    canViewList
    canViewEntityVersionMap
    isPubliclySubmitted
    suggestedWorkTypeIds
    quickQuoteIds
    proposalDocLinks {
      name
      link
      date
      __typename
    }
    priority
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetIssueQueryVariables, APITypes.GetIssueQuery>;
export const listIssues = /* GraphQL */ `query ListIssues(
  $id: ID
  $filter: ModelIssueFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listIssues(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      locationId
      propertyId
      inspectionId
      createdInSolution
      name
      description
      note
      tags
      tagIds
      status
      clientCreationDate
      localLastUpdatedTime
      createdBy
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      canViewList
      canViewEntityVersionMap
      isPubliclySubmitted
      suggestedWorkTypeIds
      quickQuoteIds
      proposalDocLinks {
        name
        link
        date
        __typename
      }
      priority
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIssuesQueryVariables,
  APITypes.ListIssuesQuery
>;
export const syncIssues = /* GraphQL */ `query SyncIssues(
  $filter: ModelIssueFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncIssues(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      locationId
      propertyId
      inspectionId
      createdInSolution
      name
      description
      note
      tags
      tagIds
      status
      clientCreationDate
      localLastUpdatedTime
      createdBy
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      canViewList
      canViewEntityVersionMap
      isPubliclySubmitted
      suggestedWorkTypeIds
      quickQuoteIds
      proposalDocLinks {
        name
        link
        date
        __typename
      }
      priority
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncIssuesQueryVariables,
  APITypes.SyncIssuesQuery
>;
export const listIssuesByLocation = /* GraphQL */ `query ListIssuesByLocation(
  $locationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelIssueFilterInput
  $limit: Int
  $nextToken: String
) {
  listIssuesByLocation(
    locationId: $locationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      locationId
      propertyId
      inspectionId
      createdInSolution
      name
      description
      note
      tags
      tagIds
      status
      clientCreationDate
      localLastUpdatedTime
      createdBy
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      canViewList
      canViewEntityVersionMap
      isPubliclySubmitted
      suggestedWorkTypeIds
      quickQuoteIds
      proposalDocLinks {
        name
        link
        date
        __typename
      }
      priority
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIssuesByLocationQueryVariables,
  APITypes.ListIssuesByLocationQuery
>;
export const listIssuesByProperty = /* GraphQL */ `query ListIssuesByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelIssueFilterInput
  $limit: Int
  $nextToken: String
) {
  listIssuesByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      locationId
      propertyId
      inspectionId
      createdInSolution
      name
      description
      note
      tags
      tagIds
      status
      clientCreationDate
      localLastUpdatedTime
      createdBy
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      canViewList
      canViewEntityVersionMap
      isPubliclySubmitted
      suggestedWorkTypeIds
      quickQuoteIds
      proposalDocLinks {
        name
        link
        date
        __typename
      }
      priority
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIssuesByPropertyQueryVariables,
  APITypes.ListIssuesByPropertyQuery
>;
export const listIssuesByInspection = /* GraphQL */ `query ListIssuesByInspection(
  $inspectionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelIssueFilterInput
  $limit: Int
  $nextToken: String
) {
  listIssuesByInspection(
    inspectionId: $inspectionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      locationId
      propertyId
      inspectionId
      createdInSolution
      name
      description
      note
      tags
      tagIds
      status
      clientCreationDate
      localLastUpdatedTime
      createdBy
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      canViewList
      canViewEntityVersionMap
      isPubliclySubmitted
      suggestedWorkTypeIds
      quickQuoteIds
      proposalDocLinks {
        name
        link
        date
        __typename
      }
      priority
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIssuesByInspectionQueryVariables,
  APITypes.ListIssuesByInspectionQuery
>;
export const getQuickQuote = /* GraphQL */ `query GetQuickQuote($id: ID!) {
  getQuickQuote(id: $id) {
    id
    propertyId
    generatedProposalId
    status
    generatedSolutionId
    issueIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQuickQuoteQueryVariables,
  APITypes.GetQuickQuoteQuery
>;
export const listQuickQuotes = /* GraphQL */ `query ListQuickQuotes(
  $id: ID
  $filter: ModelQuickQuoteFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listQuickQuotes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      generatedProposalId
      status
      generatedSolutionId
      issueIds
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListQuickQuotesQueryVariables,
  APITypes.ListQuickQuotesQuery
>;
export const syncQuickQuotes = /* GraphQL */ `query SyncQuickQuotes(
  $filter: ModelQuickQuoteFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncQuickQuotes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      generatedProposalId
      status
      generatedSolutionId
      issueIds
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncQuickQuotesQueryVariables,
  APITypes.SyncQuickQuotesQuery
>;
export const listQuickQuotesByProperty = /* GraphQL */ `query ListQuickQuotesByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelQuickQuoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuickQuotesByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      generatedProposalId
      status
      generatedSolutionId
      issueIds
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListQuickQuotesByPropertyQueryVariables,
  APITypes.ListQuickQuotesByPropertyQuery
>;
export const listQuickQuotesBySolution = /* GraphQL */ `query ListQuickQuotesBySolution(
  $generatedSolutionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelQuickQuoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuickQuotesBySolution(
    generatedSolutionId: $generatedSolutionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      generatedProposalId
      status
      generatedSolutionId
      issueIds
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListQuickQuotesBySolutionQueryVariables,
  APITypes.ListQuickQuotesBySolutionQuery
>;
export const getLocation = /* GraphQL */ `query GetLocation($id: ID!) {
  getLocation(id: $id) {
    id
    propertyId
    createdInSolution
    name
    tags
    localCreationTime
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLocationQueryVariables,
  APITypes.GetLocationQuery
>;
export const listLocations = /* GraphQL */ `query ListLocations(
  $id: ID
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLocations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      createdInSolution
      name
      tags
      localCreationTime
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLocationsQueryVariables,
  APITypes.ListLocationsQuery
>;
export const syncLocations = /* GraphQL */ `query SyncLocations(
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncLocations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      createdInSolution
      name
      tags
      localCreationTime
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncLocationsQueryVariables,
  APITypes.SyncLocationsQuery
>;
export const listLocationsByProperty = /* GraphQL */ `query ListLocationsByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listLocationsByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      createdInSolution
      name
      tags
      localCreationTime
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLocationsByPropertyQueryVariables,
  APITypes.ListLocationsByPropertyQuery
>;
export const getNote = /* GraphQL */ `query GetNote($id: ID!) {
  getNote(id: $id) {
    id
    parentId
    propertyId
    note
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetNoteQueryVariables, APITypes.GetNoteQuery>;
export const listNotes = /* GraphQL */ `query ListNotes(
  $id: ID
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listNotes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      parentId
      propertyId
      note
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListNotesQueryVariables, APITypes.ListNotesQuery>;
export const syncNotes = /* GraphQL */ `query SyncNotes(
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncNotes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      parentId
      propertyId
      note
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncNotesQueryVariables, APITypes.SyncNotesQuery>;
export const listNotesByParent = /* GraphQL */ `query ListNotesByParent(
  $parentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotesByParent(
    parentId: $parentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      parentId
      propertyId
      note
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotesByParentQueryVariables,
  APITypes.ListNotesByParentQuery
>;
export const listNotesByProperty = /* GraphQL */ `query ListNotesByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotesByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      parentId
      propertyId
      note
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotesByPropertyQueryVariables,
  APITypes.ListNotesByPropertyQuery
>;
export const getOrganization = /* GraphQL */ `query GetOrganization($id: ID!) {
  getOrganization(id: $id) {
    id
    legalName
    type
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrganizationQueryVariables,
  APITypes.GetOrganizationQuery
>;
export const listOrganizations = /* GraphQL */ `query ListOrganizations(
  $id: ID
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listOrganizations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      legalName
      type
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrganizationsQueryVariables,
  APITypes.ListOrganizationsQuery
>;
export const syncOrganizations = /* GraphQL */ `query SyncOrganizations(
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncOrganizations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      legalName
      type
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncOrganizationsQueryVariables,
  APITypes.SyncOrganizationsQuery
>;
export const getOrganizationBillingProfile = /* GraphQL */ `query GetOrganizationBillingProfile($organizationId: ID!) {
  getOrganizationBillingProfile(organizationId: $organizationId) {
    organizationId
    billingProfileId
    billingProvider
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrganizationBillingProfileQueryVariables,
  APITypes.GetOrganizationBillingProfileQuery
>;
export const listOrganizationBillingProfiles = /* GraphQL */ `query ListOrganizationBillingProfiles(
  $organizationId: ID
  $filter: ModelOrganizationBillingProfileFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listOrganizationBillingProfiles(
    organizationId: $organizationId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      organizationId
      billingProfileId
      billingProvider
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrganizationBillingProfilesQueryVariables,
  APITypes.ListOrganizationBillingProfilesQuery
>;
export const syncOrganizationBillingProfiles = /* GraphQL */ `query SyncOrganizationBillingProfiles(
  $filter: ModelOrganizationBillingProfileFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncOrganizationBillingProfiles(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      organizationId
      billingProfileId
      billingProvider
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncOrganizationBillingProfilesQueryVariables,
  APITypes.SyncOrganizationBillingProfilesQuery
>;
export const getTeam = /* GraphQL */ `query GetTeam($id: ID!) {
  getTeam(id: $id) {
    id
    organizationId
    type
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTeamQueryVariables, APITypes.GetTeamQuery>;
export const listTeams = /* GraphQL */ `query ListTeams(
  $id: ID
  $filter: ModelTeamFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTeams(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationId
      type
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTeamsQueryVariables, APITypes.ListTeamsQuery>;
export const syncTeams = /* GraphQL */ `query SyncTeams(
  $filter: ModelTeamFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTeams(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationId
      type
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncTeamsQueryVariables, APITypes.SyncTeamsQuery>;
export const listTeamsByOrganizationId = /* GraphQL */ `query ListTeamsByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamFilterInput
  $limit: Int
  $nextToken: String
) {
  listTeamsByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      type
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTeamsByOrganizationIdQueryVariables,
  APITypes.ListTeamsByOrganizationIdQuery
>;
export const getTeamMember = /* GraphQL */ `query GetTeamMember($id: ID!) {
  getTeamMember(id: $id) {
    id
    teamId
    organizationId
    userId
    joinedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTeamMemberQueryVariables,
  APITypes.GetTeamMemberQuery
>;
export const listTeamMembers = /* GraphQL */ `query ListTeamMembers(
  $id: ID
  $filter: ModelTeamMemberFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTeamMembers(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      teamId
      organizationId
      userId
      joinedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTeamMembersQueryVariables,
  APITypes.ListTeamMembersQuery
>;
export const syncTeamMembers = /* GraphQL */ `query SyncTeamMembers(
  $filter: ModelTeamMemberFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTeamMembers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      teamId
      organizationId
      userId
      joinedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTeamMembersQueryVariables,
  APITypes.SyncTeamMembersQuery
>;
export const listTeamMembersByTeamId = /* GraphQL */ `query ListTeamMembersByTeamId(
  $teamId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  listTeamMembersByTeamId(
    teamId: $teamId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      teamId
      organizationId
      userId
      joinedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTeamMembersByTeamIdQueryVariables,
  APITypes.ListTeamMembersByTeamIdQuery
>;
export const listTeamMembersByUserId = /* GraphQL */ `query ListTeamMembersByUserId(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  listTeamMembersByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      teamId
      organizationId
      userId
      joinedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTeamMembersByUserIdQueryVariables,
  APITypes.ListTeamMembersByUserIdQuery
>;
export const getAccountInvitation = /* GraphQL */ `query GetAccountInvitation($id: ID!) {
  getAccountInvitation(id: $id) {
    id
    organizationId
    role
    email
    expiresAt
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountInvitationQueryVariables,
  APITypes.GetAccountInvitationQuery
>;
export const listAccountInvitations = /* GraphQL */ `query ListAccountInvitations(
  $id: ID
  $filter: ModelAccountInvitationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAccountInvitations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationId
      role
      email
      expiresAt
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountInvitationsQueryVariables,
  APITypes.ListAccountInvitationsQuery
>;
export const syncAccountInvitations = /* GraphQL */ `query SyncAccountInvitations(
  $filter: ModelAccountInvitationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAccountInvitations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationId
      role
      email
      expiresAt
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAccountInvitationsQueryVariables,
  APITypes.SyncAccountInvitationsQuery
>;
export const listAccountInvitationsByOrganizationId = /* GraphQL */ `query ListAccountInvitationsByOrganizationId(
  $organizationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAccountInvitationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccountInvitationsByOrganizationId(
    organizationId: $organizationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationId
      role
      email
      expiresAt
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountInvitationsByOrganizationIdQueryVariables,
  APITypes.ListAccountInvitationsByOrganizationIdQuery
>;
export const getProject = /* GraphQL */ `query GetProject($id: ID!) {
  getProject(id: $id) {
    id
    propertyId
    name
    tenderNumber
    customer
    address
    propertyType
    dueDate
    contactName
    contactNumber
    contactEmail
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectQueryVariables,
  APITypes.GetProjectQuery
>;
export const listProjects = /* GraphQL */ `query ListProjects(
  $id: ID
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProjects(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      name
      tenderNumber
      customer
      address
      propertyType
      dueDate
      contactName
      contactNumber
      contactEmail
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectsQueryVariables,
  APITypes.ListProjectsQuery
>;
export const syncProjects = /* GraphQL */ `query SyncProjects(
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncProjects(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      name
      tenderNumber
      customer
      address
      propertyType
      dueDate
      contactName
      contactNumber
      contactEmail
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncProjectsQueryVariables,
  APITypes.SyncProjectsQuery
>;
export const listDesignProjectsByProperty = /* GraphQL */ `query ListDesignProjectsByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listDesignProjectsByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      name
      tenderNumber
      customer
      address
      propertyType
      dueDate
      contactName
      contactNumber
      contactEmail
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDesignProjectsByPropertyQueryVariables,
  APITypes.ListDesignProjectsByPropertyQuery
>;
export const getProjectCounter = /* GraphQL */ `query GetProjectCounter($id: ID!) {
  getProjectCounter(id: $id) {
    id
    propertyId
    latestProjectNumber
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectCounterQueryVariables,
  APITypes.GetProjectCounterQuery
>;
export const listProjectCounters = /* GraphQL */ `query ListProjectCounters(
  $id: ID
  $filter: ModelProjectCounterFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProjectCounters(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      latestProjectNumber
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectCountersQueryVariables,
  APITypes.ListProjectCountersQuery
>;
export const syncProjectCounters = /* GraphQL */ `query SyncProjectCounters(
  $filter: ModelProjectCounterFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncProjectCounters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      latestProjectNumber
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncProjectCountersQueryVariables,
  APITypes.SyncProjectCountersQuery
>;
export const getProjectCounterByProperty = /* GraphQL */ `query GetProjectCounterByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProjectCounterFilterInput
  $limit: Int
  $nextToken: String
) {
  getProjectCounterByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      latestProjectNumber
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectCounterByPropertyQueryVariables,
  APITypes.GetProjectCounterByPropertyQuery
>;
export const getProperty = /* GraphQL */ `query GetProperty($id: ID!) {
  getProperty(id: $id) {
    id
    name
    description
    address
    ownerOrganizationId
    primaryContactNumber
    primaryContactEmail
    primaryContactName
    propertyNumber
    locations {
      items {
        id
        propertyId
        createdInSolution
        name
        tags
        localCreationTime
        localLastUpdatedTime
        opaqueSyncReconciliationToken
        canView
        canEdit
        canDelete
        createdBy
        canViewList
        canViewEntityVersionMap
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdBy
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    autoDashboardRebuild
    canView
    canEdit
    canCreateSolutions
    canDelete
    canViewList
    canViewEntityVersionMap
    isTestProperty
    isArchived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPropertyQueryVariables,
  APITypes.GetPropertyQuery
>;
export const listProperties = /* GraphQL */ `query ListProperties(
  $id: ID
  $filter: ModelPropertyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProperties(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      description
      address
      ownerOrganizationId
      primaryContactNumber
      primaryContactEmail
      primaryContactName
      propertyNumber
      locations {
        items {
          id
          propertyId
          createdInSolution
          name
          tags
          localCreationTime
          localLastUpdatedTime
          opaqueSyncReconciliationToken
          canView
          canEdit
          canDelete
          createdBy
          canViewList
          canViewEntityVersionMap
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdBy
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      autoDashboardRebuild
      canView
      canEdit
      canCreateSolutions
      canDelete
      canViewList
      canViewEntityVersionMap
      isTestProperty
      isArchived
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPropertiesQueryVariables,
  APITypes.ListPropertiesQuery
>;
export const syncProperties = /* GraphQL */ `query SyncProperties(
  $filter: ModelPropertyFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncProperties(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      description
      address
      ownerOrganizationId
      primaryContactNumber
      primaryContactEmail
      primaryContactName
      propertyNumber
      locations {
        items {
          id
          propertyId
          createdInSolution
          name
          tags
          localCreationTime
          localLastUpdatedTime
          opaqueSyncReconciliationToken
          canView
          canEdit
          canDelete
          createdBy
          canViewList
          canViewEntityVersionMap
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdBy
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      autoDashboardRebuild
      canView
      canEdit
      canCreateSolutions
      canDelete
      canViewList
      canViewEntityVersionMap
      isTestProperty
      isArchived
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPropertiesQueryVariables,
  APITypes.SyncPropertiesQuery
>;
export const getPropertyCounter = /* GraphQL */ `query GetPropertyCounter($id: ID!) {
  getPropertyCounter(id: $id) {
    id
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPropertyCounterQueryVariables,
  APITypes.GetPropertyCounterQuery
>;
export const listPropertyCounters = /* GraphQL */ `query ListPropertyCounters(
  $filter: ModelPropertyCounterFilterInput
  $limit: Int
  $nextToken: String
) {
  listPropertyCounters(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPropertyCountersQueryVariables,
  APITypes.ListPropertyCountersQuery
>;
export const syncPropertyCounters = /* GraphQL */ `query SyncPropertyCounters(
  $filter: ModelPropertyCounterFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPropertyCounters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPropertyCountersQueryVariables,
  APITypes.SyncPropertyCountersQuery
>;
export const getProposal = /* GraphQL */ `query GetProposal($id: ID!) {
  getProposal(id: $id) {
    id
    schemaVersion
    designDocumentGroupId
    designDocumentVersion
    proposalKey
    proposalNumber
    status
    author
    createdAt
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    quickQuoteId
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProposalQueryVariables,
  APITypes.GetProposalQuery
>;
export const listProposals = /* GraphQL */ `query ListProposals(
  $filter: ModelProposalFilterInput
  $limit: Int
  $nextToken: String
) {
  listProposals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      schemaVersion
      designDocumentGroupId
      designDocumentVersion
      proposalKey
      proposalNumber
      status
      author
      createdAt
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      quickQuoteId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProposalsQueryVariables,
  APITypes.ListProposalsQuery
>;
export const syncProposals = /* GraphQL */ `query SyncProposals(
  $filter: ModelProposalFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncProposals(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      schemaVersion
      designDocumentGroupId
      designDocumentVersion
      proposalKey
      proposalNumber
      status
      author
      createdAt
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      quickQuoteId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncProposalsQueryVariables,
  APITypes.SyncProposalsQuery
>;
export const getProposalById = /* GraphQL */ `query GetProposalById(
  $id: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProposalFilterInput
  $limit: Int
  $nextToken: String
) {
  getProposalById(
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      schemaVersion
      designDocumentGroupId
      designDocumentVersion
      proposalKey
      proposalNumber
      status
      author
      createdAt
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      quickQuoteId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProposalByIdQueryVariables,
  APITypes.GetProposalByIdQuery
>;
export const listProposalsByDesignDocumentGroupId = /* GraphQL */ `query ListProposalsByDesignDocumentGroupId(
  $designDocumentGroupId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProposalFilterInput
  $limit: Int
  $nextToken: String
) {
  listProposalsByDesignDocumentGroupId(
    designDocumentGroupId: $designDocumentGroupId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      schemaVersion
      designDocumentGroupId
      designDocumentVersion
      proposalKey
      proposalNumber
      status
      author
      createdAt
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      quickQuoteId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProposalsByDesignDocumentGroupIdQueryVariables,
  APITypes.ListProposalsByDesignDocumentGroupIdQuery
>;
export const listProposalsByDesignDocumentGroupIdAndVersion = /* GraphQL */ `query ListProposalsByDesignDocumentGroupIdAndVersion(
  $designDocumentGroupId: ID!
  $designDocumentVersion: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProposalFilterInput
  $limit: Int
  $nextToken: String
) {
  listProposalsByDesignDocumentGroupIdAndVersion(
    designDocumentGroupId: $designDocumentGroupId
    designDocumentVersion: $designDocumentVersion
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      schemaVersion
      designDocumentGroupId
      designDocumentVersion
      proposalKey
      proposalNumber
      status
      author
      createdAt
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      quickQuoteId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProposalsByDesignDocumentGroupIdAndVersionQueryVariables,
  APITypes.ListProposalsByDesignDocumentGroupIdAndVersionQuery
>;
export const getProposalByProposalNumber = /* GraphQL */ `query GetProposalByProposalNumber(
  $proposalNumber: Int!
  $sortDirection: ModelSortDirection
  $filter: ModelProposalFilterInput
  $limit: Int
  $nextToken: String
) {
  getProposalByProposalNumber(
    proposalNumber: $proposalNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      schemaVersion
      designDocumentGroupId
      designDocumentVersion
      proposalKey
      proposalNumber
      status
      author
      createdAt
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      quickQuoteId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProposalByProposalNumberQueryVariables,
  APITypes.GetProposalByProposalNumberQuery
>;
export const listProposalsByAuthor = /* GraphQL */ `query ListProposalsByAuthor(
  $author: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProposalFilterInput
  $limit: Int
  $nextToken: String
) {
  listProposalsByAuthor(
    author: $author
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      schemaVersion
      designDocumentGroupId
      designDocumentVersion
      proposalKey
      proposalNumber
      status
      author
      createdAt
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      quickQuoteId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProposalsByAuthorQueryVariables,
  APITypes.ListProposalsByAuthorQuery
>;
export const getProposalCounter = /* GraphQL */ `query GetProposalCounter($id: ID!) {
  getProposalCounter(id: $id) {
    id
    solutionGroupId
    solutionVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProposalCounterQueryVariables,
  APITypes.GetProposalCounterQuery
>;
export const listProposalCounters = /* GraphQL */ `query ListProposalCounters(
  $id: ID
  $filter: ModelProposalCounterFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProposalCounters(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      solutionGroupId
      solutionVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProposalCountersQueryVariables,
  APITypes.ListProposalCountersQuery
>;
export const syncProposalCounters = /* GraphQL */ `query SyncProposalCounters(
  $filter: ModelProposalCounterFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncProposalCounters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      solutionGroupId
      solutionVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncProposalCountersQueryVariables,
  APITypes.SyncProposalCountersQuery
>;
export const getProposalCounterBySolutionByVersion = /* GraphQL */ `query GetProposalCounterBySolutionByVersion(
  $solutionGroupId: ID!
  $solutionVersion: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProposalCounterFilterInput
  $limit: Int
  $nextToken: String
) {
  getProposalCounterBySolutionByVersion(
    solutionGroupId: $solutionGroupId
    solutionVersion: $solutionVersion
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      solutionGroupId
      solutionVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProposalCounterBySolutionByVersionQueryVariables,
  APITypes.GetProposalCounterBySolutionByVersionQuery
>;
export const getResourceUserPermissions = /* GraphQL */ `query GetResourceUserPermissions($id: ID!) {
  getResourceUserPermissions(id: $id) {
    id
    resourceId
    userId
    userEmail
    userFullName
    resourceAndUserId
    permissions
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetResourceUserPermissionsQueryVariables,
  APITypes.GetResourceUserPermissionsQuery
>;
export const listResourceUserPermissions = /* GraphQL */ `query ListResourceUserPermissions(
  $id: ID
  $filter: ModelResourceUserPermissionsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listResourceUserPermissions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      resourceId
      userId
      userEmail
      userFullName
      resourceAndUserId
      permissions
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceUserPermissionsQueryVariables,
  APITypes.ListResourceUserPermissionsQuery
>;
export const syncResourceUserPermissions = /* GraphQL */ `query SyncResourceUserPermissions(
  $filter: ModelResourceUserPermissionsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncResourceUserPermissions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      resourceId
      userId
      userEmail
      userFullName
      resourceAndUserId
      permissions
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncResourceUserPermissionsQueryVariables,
  APITypes.SyncResourceUserPermissionsQuery
>;
export const listResourceUserPermissionsByResource = /* GraphQL */ `query ListResourceUserPermissionsByResource(
  $resourceId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelResourceUserPermissionsFilterInput
  $limit: Int
  $nextToken: String
) {
  listResourceUserPermissionsByResource(
    resourceId: $resourceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      resourceId
      userId
      userEmail
      userFullName
      resourceAndUserId
      permissions
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceUserPermissionsByResourceQueryVariables,
  APITypes.ListResourceUserPermissionsByResourceQuery
>;
export const listResourceUserPermissionsByUserIdAndResourceType = /* GraphQL */ `query ListResourceUserPermissionsByUserIdAndResourceType(
  $userId: String!
  $resourceType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelResourceUserPermissionsFilterInput
  $limit: Int
  $nextToken: String
) {
  listResourceUserPermissionsByUserIdAndResourceType(
    userId: $userId
    resourceType: $resourceType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      resourceId
      userId
      userEmail
      userFullName
      resourceAndUserId
      permissions
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceUserPermissionsByUserIdAndResourceTypeQueryVariables,
  APITypes.ListResourceUserPermissionsByUserIdAndResourceTypeQuery
>;
export const listResourceUserPermissionsByUserEmail = /* GraphQL */ `query ListResourceUserPermissionsByUserEmail(
  $userEmail: String!
  $sortDirection: ModelSortDirection
  $filter: ModelResourceUserPermissionsFilterInput
  $limit: Int
  $nextToken: String
) {
  listResourceUserPermissionsByUserEmail(
    userEmail: $userEmail
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      resourceId
      userId
      userEmail
      userFullName
      resourceAndUserId
      permissions
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceUserPermissionsByUserEmailQueryVariables,
  APITypes.ListResourceUserPermissionsByUserEmailQuery
>;
export const listResourceUserPermissionsByResourceAndUser = /* GraphQL */ `query ListResourceUserPermissionsByResourceAndUser(
  $resourceAndUserId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelResourceUserPermissionsFilterInput
  $limit: Int
  $nextToken: String
) {
  listResourceUserPermissionsByResourceAndUser(
    resourceAndUserId: $resourceAndUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      resourceId
      userId
      userEmail
      userFullName
      resourceAndUserId
      permissions
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceUserPermissionsByResourceAndUserQueryVariables,
  APITypes.ListResourceUserPermissionsByResourceAndUserQuery
>;
export const getSolution = /* GraphQL */ `query GetSolution($id: ID!) {
  getSolution(id: $id) {
    id
    propertyId
    projectId
    name
    status
    latestMinorVersion
    latestContentKey
    serialNumber
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      tenderingType
      warranty
      __typename
    }
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    isArchived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSolutionQueryVariables,
  APITypes.GetSolutionQuery
>;
export const listSolutions = /* GraphQL */ `query ListSolutions(
  $id: ID
  $filter: ModelSolutionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSolutions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      projectId
      name
      status
      latestMinorVersion
      latestContentKey
      serialNumber
      metadata {
        name
        propertyContactName
        propertyAddress
        propertyType
        solutionDueDate
        consultantName
        consultantPhoneNumber
        consultantEmail
        tenderingType
        warranty
        __typename
      }
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      isArchived
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSolutionsQueryVariables,
  APITypes.ListSolutionsQuery
>;
export const syncSolutions = /* GraphQL */ `query SyncSolutions(
  $filter: ModelSolutionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSolutions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      projectId
      name
      status
      latestMinorVersion
      latestContentKey
      serialNumber
      metadata {
        name
        propertyContactName
        propertyAddress
        propertyType
        solutionDueDate
        consultantName
        consultantPhoneNumber
        consultantEmail
        tenderingType
        warranty
        __typename
      }
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      isArchived
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSolutionsQueryVariables,
  APITypes.SyncSolutionsQuery
>;
export const listSolutionsByProperty = /* GraphQL */ `query ListSolutionsByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSolutionFilterInput
  $limit: Int
  $nextToken: String
) {
  listSolutionsByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      projectId
      name
      status
      latestMinorVersion
      latestContentKey
      serialNumber
      metadata {
        name
        propertyContactName
        propertyAddress
        propertyType
        solutionDueDate
        consultantName
        consultantPhoneNumber
        consultantEmail
        tenderingType
        warranty
        __typename
      }
      localLastUpdatedTime
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      isArchived
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSolutionsByPropertyQueryVariables,
  APITypes.ListSolutionsByPropertyQuery
>;
export const getSolutionMinorVersion = /* GraphQL */ `query GetSolutionMinorVersion($id: ID!) {
  getSolutionMinorVersion(id: $id) {
    id
    solutionId
    propertyId
    name
    contentKey
    minorVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSolutionMinorVersionQueryVariables,
  APITypes.GetSolutionMinorVersionQuery
>;
export const listSolutionMinorVersions = /* GraphQL */ `query ListSolutionMinorVersions(
  $id: ID
  $filter: ModelSolutionMinorVersionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSolutionMinorVersions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      solutionId
      propertyId
      name
      contentKey
      minorVersion
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSolutionMinorVersionsQueryVariables,
  APITypes.ListSolutionMinorVersionsQuery
>;
export const syncSolutionMinorVersions = /* GraphQL */ `query SyncSolutionMinorVersions(
  $filter: ModelSolutionMinorVersionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSolutionMinorVersions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      solutionId
      propertyId
      name
      contentKey
      minorVersion
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSolutionMinorVersionsQueryVariables,
  APITypes.SyncSolutionMinorVersionsQuery
>;
export const listSolutionMinorVersionsBySolutionByMinorVersion = /* GraphQL */ `query ListSolutionMinorVersionsBySolutionByMinorVersion(
  $solutionId: ID!
  $minorVersion: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSolutionMinorVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  listSolutionMinorVersionsBySolutionByMinorVersion(
    solutionId: $solutionId
    minorVersion: $minorVersion
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      solutionId
      propertyId
      name
      contentKey
      minorVersion
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSolutionMinorVersionsBySolutionByMinorVersionQueryVariables,
  APITypes.ListSolutionMinorVersionsBySolutionByMinorVersionQuery
>;
export const getSolutionGroupCounter = /* GraphQL */ `query GetSolutionGroupCounter($id: ID!) {
  getSolutionGroupCounter(id: $id) {
    id
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSolutionGroupCounterQueryVariables,
  APITypes.GetSolutionGroupCounterQuery
>;
export const listSolutionGroupCounters = /* GraphQL */ `query ListSolutionGroupCounters(
  $id: ID
  $filter: ModelSolutionGroupCounterFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSolutionGroupCounters(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSolutionGroupCountersQueryVariables,
  APITypes.ListSolutionGroupCountersQuery
>;
export const syncSolutionGroupCounters = /* GraphQL */ `query SyncSolutionGroupCounters(
  $filter: ModelSolutionGroupCounterFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSolutionGroupCounters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSolutionGroupCountersQueryVariables,
  APITypes.SyncSolutionGroupCountersQuery
>;
export const getSolutionGroupCounterByProperty = /* GraphQL */ `query GetSolutionGroupCounterByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSolutionGroupCounterFilterInput
  $limit: Int
  $nextToken: String
) {
  getSolutionGroupCounterByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSolutionGroupCounterByPropertyQueryVariables,
  APITypes.GetSolutionGroupCounterByPropertyQuery
>;
export const getUserGroup = /* GraphQL */ `query GetUserGroup($id: ID!) {
  getUserGroup(id: $id) {
    id
    resourceId
    groupType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserGroupQueryVariables,
  APITypes.GetUserGroupQuery
>;
export const listUserGroups = /* GraphQL */ `query ListUserGroups(
  $id: ID
  $filter: ModelUserGroupFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserGroups(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      resourceId
      groupType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserGroupsQueryVariables,
  APITypes.ListUserGroupsQuery
>;
export const syncUserGroups = /* GraphQL */ `query SyncUserGroups(
  $filter: ModelUserGroupFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserGroups(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      resourceId
      groupType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserGroupsQueryVariables,
  APITypes.SyncUserGroupsQuery
>;
export const listUserGroupsByResource = /* GraphQL */ `query ListUserGroupsByResource(
  $resourceId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserGroupsByResource(
    resourceId: $resourceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      resourceId
      groupType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserGroupsByResourceQueryVariables,
  APITypes.ListUserGroupsByResourceQuery
>;
export const getUserGroupMember = /* GraphQL */ `query GetUserGroupMember($id: ID!) {
  getUserGroupMember(id: $id) {
    id
    resourceId
    resourceAndUserId
    userId
    userGroupId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserGroupMemberQueryVariables,
  APITypes.GetUserGroupMemberQuery
>;
export const listUserGroupMembers = /* GraphQL */ `query ListUserGroupMembers(
  $id: ID
  $filter: ModelUserGroupMemberFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserGroupMembers(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      resourceId
      resourceAndUserId
      userId
      userGroupId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserGroupMembersQueryVariables,
  APITypes.ListUserGroupMembersQuery
>;
export const syncUserGroupMembers = /* GraphQL */ `query SyncUserGroupMembers(
  $filter: ModelUserGroupMemberFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserGroupMembers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      resourceId
      resourceAndUserId
      userId
      userGroupId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserGroupMembersQueryVariables,
  APITypes.SyncUserGroupMembersQuery
>;
export const listUserGroupMembersByResource = /* GraphQL */ `query ListUserGroupMembersByResource(
  $resourceId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserGroupMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserGroupMembersByResource(
    resourceId: $resourceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      resourceId
      resourceAndUserId
      userId
      userGroupId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserGroupMembersByResourceQueryVariables,
  APITypes.ListUserGroupMembersByResourceQuery
>;
export const listUserGroupMembersByResourceAndUser = /* GraphQL */ `query ListUserGroupMembersByResourceAndUser(
  $resourceAndUserId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserGroupMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserGroupMembersByResourceAndUser(
    resourceAndUserId: $resourceAndUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      resourceId
      resourceAndUserId
      userId
      userGroupId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserGroupMembersByResourceAndUserQueryVariables,
  APITypes.ListUserGroupMembersByResourceAndUserQuery
>;
export const getUserOrganizationAssociation = /* GraphQL */ `query GetUserOrganizationAssociation($id: ID!) {
  getUserOrganizationAssociation(id: $id) {
    id
    userId
    organizationId
    associationType
    permissions
    role
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserOrganizationAssociationQueryVariables,
  APITypes.GetUserOrganizationAssociationQuery
>;
export const listUserOrganizationAssociations = /* GraphQL */ `query ListUserOrganizationAssociations(
  $id: ID
  $filter: ModelUserOrganizationAssociationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserOrganizationAssociations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userId
      organizationId
      associationType
      permissions
      role
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserOrganizationAssociationsQueryVariables,
  APITypes.ListUserOrganizationAssociationsQuery
>;
export const syncUserOrganizationAssociations = /* GraphQL */ `query SyncUserOrganizationAssociations(
  $filter: ModelUserOrganizationAssociationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserOrganizationAssociations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userId
      organizationId
      associationType
      permissions
      role
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserOrganizationAssociationsQueryVariables,
  APITypes.SyncUserOrganizationAssociationsQuery
>;
export const listUserOrganizationAssociationsByUserAndAssociationType = /* GraphQL */ `query ListUserOrganizationAssociationsByUserAndAssociationType(
  $userId: ID!
  $associationType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserOrganizationAssociationFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserOrganizationAssociationsByUserAndAssociationType(
    userId: $userId
    associationType: $associationType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      organizationId
      associationType
      permissions
      role
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserOrganizationAssociationsByUserAndAssociationTypeQueryVariables,
  APITypes.ListUserOrganizationAssociationsByUserAndAssociationTypeQuery
>;
export const listUserOrganizationAssociationsByOrganizationAndAssociationType = /* GraphQL */ `query ListUserOrganizationAssociationsByOrganizationAndAssociationType(
  $organizationId: ID!
  $associationType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserOrganizationAssociationFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserOrganizationAssociationsByOrganizationAndAssociationType(
    organizationId: $organizationId
    associationType: $associationType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      organizationId
      associationType
      permissions
      role
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserOrganizationAssociationsByOrganizationAndAssociationTypeQueryVariables,
  APITypes.ListUserOrganizationAssociationsByOrganizationAndAssociationTypeQuery
>;
export const getWorkSpecification = /* GraphQL */ `query GetWorkSpecification($id: ID!) {
  getWorkSpecification(id: $id) {
    id
    dimensionId
    issueId
    propertyId
    createdInSolution
    body
    description
    workTypeId
    itemNumber
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    version
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkSpecificationQueryVariables,
  APITypes.GetWorkSpecificationQuery
>;
export const listWorkSpecifications = /* GraphQL */ `query ListWorkSpecifications(
  $id: ID
  $filter: ModelWorkSpecificationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWorkSpecifications(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      dimensionId
      issueId
      propertyId
      createdInSolution
      body
      description
      workTypeId
      itemNumber
      measurement {
        length
        width
        dimensionType
        measurementUnit
        __typename
      }
      version
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkSpecificationsQueryVariables,
  APITypes.ListWorkSpecificationsQuery
>;
export const syncWorkSpecifications = /* GraphQL */ `query SyncWorkSpecifications(
  $filter: ModelWorkSpecificationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncWorkSpecifications(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      dimensionId
      issueId
      propertyId
      createdInSolution
      body
      description
      workTypeId
      itemNumber
      measurement {
        length
        width
        dimensionType
        measurementUnit
        __typename
      }
      version
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncWorkSpecificationsQueryVariables,
  APITypes.SyncWorkSpecificationsQuery
>;
export const listWorkScopeSpecificationsByDimensionId = /* GraphQL */ `query ListWorkScopeSpecificationsByDimensionId(
  $dimensionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelWorkSpecificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listWorkScopeSpecificationsByDimensionId(
    dimensionId: $dimensionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      dimensionId
      issueId
      propertyId
      createdInSolution
      body
      description
      workTypeId
      itemNumber
      measurement {
        length
        width
        dimensionType
        measurementUnit
        __typename
      }
      version
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkScopeSpecificationsByDimensionIdQueryVariables,
  APITypes.ListWorkScopeSpecificationsByDimensionIdQuery
>;
export const listWorkScopeSpecificationsByIssueId = /* GraphQL */ `query ListWorkScopeSpecificationsByIssueId(
  $issueId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelWorkSpecificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listWorkScopeSpecificationsByIssueId(
    issueId: $issueId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      dimensionId
      issueId
      propertyId
      createdInSolution
      body
      description
      workTypeId
      itemNumber
      measurement {
        length
        width
        dimensionType
        measurementUnit
        __typename
      }
      version
      localLastUpdatedTime
      opaqueSyncReconciliationToken
      canView
      canEdit
      canDelete
      createdBy
      canViewList
      canViewEntityVersionMap
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkScopeSpecificationsByIssueIdQueryVariables,
  APITypes.ListWorkScopeSpecificationsByIssueIdQuery
>;
export const getWorkType = /* GraphQL */ `query GetWorkType($id: ID!) {
  getWorkType(id: $id) {
    id
    name
    shortDescription
    longDescription
    groupName
    unitPrice
    unitCost
    dimensionType
    measurementUnit
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkTypeQueryVariables,
  APITypes.GetWorkTypeQuery
>;
export const listWorkTypes = /* GraphQL */ `query ListWorkTypes(
  $id: ID
  $filter: ModelWorkTypeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWorkTypes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      shortDescription
      longDescription
      groupName
      unitPrice
      unitCost
      dimensionType
      measurementUnit
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkTypesQueryVariables,
  APITypes.ListWorkTypesQuery
>;
export const syncWorkTypes = /* GraphQL */ `query SyncWorkTypes(
  $filter: ModelWorkTypeFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncWorkTypes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      shortDescription
      longDescription
      groupName
      unitPrice
      unitCost
      dimensionType
      measurementUnit
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncWorkTypesQueryVariables,
  APITypes.SyncWorkTypesQuery
>;
export const getWorkTypeGroup = /* GraphQL */ `query GetWorkTypeGroup($id: ID!) {
  getWorkTypeGroup(id: $id) {
    id
    latestWorkTypeVersion
    environmentAgnosticWorkTypeGroupId
    isDiscoverable
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkTypeGroupQueryVariables,
  APITypes.GetWorkTypeGroupQuery
>;
export const listWorkTypeGroups = /* GraphQL */ `query ListWorkTypeGroups(
  $id: ID
  $filter: ModelWorkTypeGroupFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWorkTypeGroups(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      latestWorkTypeVersion
      environmentAgnosticWorkTypeGroupId
      isDiscoverable
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkTypeGroupsQueryVariables,
  APITypes.ListWorkTypeGroupsQuery
>;
export const syncWorkTypeGroups = /* GraphQL */ `query SyncWorkTypeGroups(
  $filter: ModelWorkTypeGroupFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncWorkTypeGroups(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      latestWorkTypeVersion
      environmentAgnosticWorkTypeGroupId
      isDiscoverable
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncWorkTypeGroupsQueryVariables,
  APITypes.SyncWorkTypeGroupsQuery
>;
export const getWorkTypePricing = /* GraphQL */ `query GetWorkTypePricing($id: ID!) {
  getWorkTypePricing(id: $id) {
    id
    entityId
    workTypeGroupId
    body
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkTypePricingQueryVariables,
  APITypes.GetWorkTypePricingQuery
>;
export const listWorkTypePricings = /* GraphQL */ `query ListWorkTypePricings(
  $id: ID
  $filter: ModelWorkTypePricingFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWorkTypePricings(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      entityId
      workTypeGroupId
      body
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkTypePricingsQueryVariables,
  APITypes.ListWorkTypePricingsQuery
>;
export const syncWorkTypePricings = /* GraphQL */ `query SyncWorkTypePricings(
  $filter: ModelWorkTypePricingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncWorkTypePricings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityId
      workTypeGroupId
      body
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncWorkTypePricingsQueryVariables,
  APITypes.SyncWorkTypePricingsQuery
>;
export const listWorkTypePricingByEntityIdByWorkTypeGroupId = /* GraphQL */ `query ListWorkTypePricingByEntityIdByWorkTypeGroupId(
  $entityId: ID!
  $workTypeGroupId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelWorkTypePricingFilterInput
  $limit: Int
  $nextToken: String
) {
  listWorkTypePricingByEntityIdByWorkTypeGroupId(
    entityId: $entityId
    workTypeGroupId: $workTypeGroupId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      entityId
      workTypeGroupId
      body
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkTypePricingByEntityIdByWorkTypeGroupIdQueryVariables,
  APITypes.ListWorkTypePricingByEntityIdByWorkTypeGroupIdQuery
>;
export const getDefaultWorkTypePricing = /* GraphQL */ `query GetDefaultWorkTypePricing($id: ID!) {
  getDefaultWorkTypePricing(id: $id) {
    id
    unitCost
    unitPrice
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDefaultWorkTypePricingQueryVariables,
  APITypes.GetDefaultWorkTypePricingQuery
>;
export const listDefaultWorkTypePricings = /* GraphQL */ `query ListDefaultWorkTypePricings(
  $id: ID
  $filter: ModelDefaultWorkTypePricingFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDefaultWorkTypePricings(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      unitCost
      unitPrice
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDefaultWorkTypePricingsQueryVariables,
  APITypes.ListDefaultWorkTypePricingsQuery
>;
export const syncDefaultWorkTypePricings = /* GraphQL */ `query SyncDefaultWorkTypePricings(
  $filter: ModelDefaultWorkTypePricingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDefaultWorkTypePricings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      unitCost
      unitPrice
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDefaultWorkTypePricingsQueryVariables,
  APITypes.SyncDefaultWorkTypePricingsQuery
>;
export const getTemporaryWorkType = /* GraphQL */ `query GetTemporaryWorkType($id: ID!) {
  getTemporaryWorkType(id: $id) {
    id
    workTypeGroupId
    environmentAgnosticWorkTypeGroupId
    body
    version
    schemaVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemporaryWorkTypeQueryVariables,
  APITypes.GetTemporaryWorkTypeQuery
>;
export const listTemporaryWorkTypes = /* GraphQL */ `query ListTemporaryWorkTypes(
  $filter: ModelTemporaryWorkTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listTemporaryWorkTypes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workTypeGroupId
      environmentAgnosticWorkTypeGroupId
      body
      version
      schemaVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemporaryWorkTypesQueryVariables,
  APITypes.ListTemporaryWorkTypesQuery
>;
export const syncTemporaryWorkTypes = /* GraphQL */ `query SyncTemporaryWorkTypes(
  $filter: ModelTemporaryWorkTypeFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTemporaryWorkTypes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      workTypeGroupId
      environmentAgnosticWorkTypeGroupId
      body
      version
      schemaVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTemporaryWorkTypesQueryVariables,
  APITypes.SyncTemporaryWorkTypesQuery
>;
export const getWorkTypeByWorkTypeGroupIdAndVersion = /* GraphQL */ `query GetWorkTypeByWorkTypeGroupIdAndVersion(
  $workTypeGroupId: ID!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemporaryWorkTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  getWorkTypeByWorkTypeGroupIdAndVersion(
    workTypeGroupId: $workTypeGroupId
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workTypeGroupId
      environmentAgnosticWorkTypeGroupId
      body
      version
      schemaVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkTypeByWorkTypeGroupIdAndVersionQueryVariables,
  APITypes.GetWorkTypeByWorkTypeGroupIdAndVersionQuery
>;
export const getWorkTypeByEnvironmentAgnosticWorkTypeGroupId = /* GraphQL */ `query GetWorkTypeByEnvironmentAgnosticWorkTypeGroupId(
  $environmentAgnosticWorkTypeGroupId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTemporaryWorkTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  getWorkTypeByEnvironmentAgnosticWorkTypeGroupId(
    environmentAgnosticWorkTypeGroupId: $environmentAgnosticWorkTypeGroupId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workTypeGroupId
      environmentAgnosticWorkTypeGroupId
      body
      version
      schemaVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkTypeByEnvironmentAgnosticWorkTypeGroupIdQueryVariables,
  APITypes.GetWorkTypeByEnvironmentAgnosticWorkTypeGroupIdQuery
>;
export const getTender = /* GraphQL */ `query GetTender($id: ID!) {
  getTender(id: $id) {
    id
    solutionId
    status
    latestVersion
    awardedVersion
    projectNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTenderQueryVariables, APITypes.GetTenderQuery>;
export const listTenders = /* GraphQL */ `query ListTenders(
  $filter: ModelTenderFilterInput
  $limit: Int
  $nextToken: String
) {
  listTenders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      solutionId
      status
      latestVersion
      awardedVersion
      projectNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTendersQueryVariables,
  APITypes.ListTendersQuery
>;
export const syncTenders = /* GraphQL */ `query SyncTenders(
  $filter: ModelTenderFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTenders(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      solutionId
      status
      latestVersion
      awardedVersion
      projectNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTendersQueryVariables,
  APITypes.SyncTendersQuery
>;
export const listTendersByProjectNumber = /* GraphQL */ `query ListTendersByProjectNumber(
  $projectNumber: Int!
  $sortDirection: ModelSortDirection
  $filter: ModelTenderFilterInput
  $limit: Int
  $nextToken: String
) {
  listTendersByProjectNumber(
    projectNumber: $projectNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      solutionId
      status
      latestVersion
      awardedVersion
      projectNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTendersByProjectNumberQueryVariables,
  APITypes.ListTendersByProjectNumberQuery
>;
export const getTenderMinorVersion = /* GraphQL */ `query GetTenderMinorVersion($id: ID!) {
  getTenderMinorVersion(id: $id) {
    id
    tenderId
    version
    solutionId
    solutionMinorVersion
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      __typename
    }
    contentKey
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTenderMinorVersionQueryVariables,
  APITypes.GetTenderMinorVersionQuery
>;
export const listTenderMinorVersions = /* GraphQL */ `query ListTenderMinorVersions(
  $filter: ModelTenderMinorVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTenderMinorVersions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenderId
      version
      solutionId
      solutionMinorVersion
      metadata {
        name
        propertyContactName
        propertyAddress
        propertyType
        solutionDueDate
        consultantName
        consultantPhoneNumber
        consultantEmail
        __typename
      }
      contentKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTenderMinorVersionsQueryVariables,
  APITypes.ListTenderMinorVersionsQuery
>;
export const syncTenderMinorVersions = /* GraphQL */ `query SyncTenderMinorVersions(
  $filter: ModelTenderMinorVersionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTenderMinorVersions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      tenderId
      version
      solutionId
      solutionMinorVersion
      metadata {
        name
        propertyContactName
        propertyAddress
        propertyType
        solutionDueDate
        consultantName
        consultantPhoneNumber
        consultantEmail
        __typename
      }
      contentKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTenderMinorVersionsQueryVariables,
  APITypes.SyncTenderMinorVersionsQuery
>;
export const listTenderMinorVersionsByTenderId = /* GraphQL */ `query ListTenderMinorVersionsByTenderId(
  $tenderId: String!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTenderMinorVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTenderMinorVersionsByTenderId(
    tenderId: $tenderId
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenderId
      version
      solutionId
      solutionMinorVersion
      metadata {
        name
        propertyContactName
        propertyAddress
        propertyType
        solutionDueDate
        consultantName
        consultantPhoneNumber
        consultantEmail
        __typename
      }
      contentKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTenderMinorVersionsByTenderIdQueryVariables,
  APITypes.ListTenderMinorVersionsByTenderIdQuery
>;
export const getTag = /* GraphQL */ `query GetTag($id: ID!) {
  getTag(id: $id) {
    id
    name
    createdBy
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTagQueryVariables, APITypes.GetTagQuery>;
export const listTags = /* GraphQL */ `query ListTags(
  $id: ID
  $filter: ModelTagFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTags(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      createdBy
      propertyId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTagsQueryVariables, APITypes.ListTagsQuery>;
export const syncTags = /* GraphQL */ `query SyncTags(
  $filter: ModelTagFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTags(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      createdBy
      propertyId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncTagsQueryVariables, APITypes.SyncTagsQuery>;
export const getUserOnboardingProgress = /* GraphQL */ `query GetUserOnboardingProgress($id: ID!) {
  getUserOnboardingProgress(id: $id) {
    id
    userId
    hasUserBeenAssociatedWithOrganization
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserOnboardingProgressQueryVariables,
  APITypes.GetUserOnboardingProgressQuery
>;
export const listUserOnboardingProgresses = /* GraphQL */ `query ListUserOnboardingProgresses(
  $id: ID
  $filter: ModelUserOnboardingProgressFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserOnboardingProgresses(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userId
      hasUserBeenAssociatedWithOrganization
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserOnboardingProgressesQueryVariables,
  APITypes.ListUserOnboardingProgressesQuery
>;
export const syncUserOnboardingProgresses = /* GraphQL */ `query SyncUserOnboardingProgresses(
  $filter: ModelUserOnboardingProgressFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserOnboardingProgresses(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userId
      hasUserBeenAssociatedWithOrganization
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserOnboardingProgressesQueryVariables,
  APITypes.SyncUserOnboardingProgressesQuery
>;
export const getUserOnboardingProgressByUserId = /* GraphQL */ `query GetUserOnboardingProgressByUserId(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserOnboardingProgressFilterInput
  $limit: Int
  $nextToken: String
) {
  getUserOnboardingProgressByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      hasUserBeenAssociatedWithOrganization
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserOnboardingProgressByUserIdQueryVariables,
  APITypes.GetUserOnboardingProgressByUserIdQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    name
    email
    phoneNumber
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $id: ID
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUsers(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      email
      phoneNumber
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const syncUsers = /* GraphQL */ `query SyncUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      email
      phoneNumber
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncUsersQueryVariables, APITypes.SyncUsersQuery>;
export const listUsersByEmail = /* GraphQL */ `query ListUsersByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsersByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      email
      phoneNumber
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsersByEmailQueryVariables,
  APITypes.ListUsersByEmailQuery
>;
export const listUsersByPhoneNumber = /* GraphQL */ `query ListUsersByPhoneNumber(
  $phoneNumber: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsersByPhoneNumber(
    phoneNumber: $phoneNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      email
      phoneNumber
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsersByPhoneNumberQueryVariables,
  APITypes.ListUsersByPhoneNumberQuery
>;
export const getTemplate = /* GraphQL */ `query GetTemplate($id: ID!) {
  getTemplate(id: $id) {
    id
    type
    name
    s3Key
    ownerId
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemplateQueryVariables,
  APITypes.GetTemplateQuery
>;
export const listTemplates = /* GraphQL */ `query ListTemplates(
  $id: ID
  $filter: ModelTemplateFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTemplates(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      type
      name
      s3Key
      ownerId
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemplatesQueryVariables,
  APITypes.ListTemplatesQuery
>;
export const syncTemplates = /* GraphQL */ `query SyncTemplates(
  $filter: ModelTemplateFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTemplates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      type
      name
      s3Key
      ownerId
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTemplatesQueryVariables,
  APITypes.SyncTemplatesQuery
>;
export const listTemplatesByOwnerEntityId = /* GraphQL */ `query ListTemplatesByOwnerEntityId(
  $ownerId: String!
  $ownerType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listTemplatesByOwnerEntityId(
    ownerId: $ownerId
    ownerType: $ownerType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      name
      s3Key
      ownerId
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemplatesByOwnerEntityIdQueryVariables,
  APITypes.ListTemplatesByOwnerEntityIdQuery
>;
export const getTemporaryAuthorizationCode = /* GraphQL */ `query GetTemporaryAuthorizationCode($id: ID!) {
  getTemporaryAuthorizationCode(id: $id) {
    id
    code
    userId
    expiresAt
    createdAt
    ttl
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemporaryAuthorizationCodeQueryVariables,
  APITypes.GetTemporaryAuthorizationCodeQuery
>;
export const listTemporaryAuthorizationCodes = /* GraphQL */ `query ListTemporaryAuthorizationCodes(
  $id: ID
  $filter: ModelTemporaryAuthorizationCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTemporaryAuthorizationCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      code
      userId
      expiresAt
      createdAt
      ttl
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemporaryAuthorizationCodesQueryVariables,
  APITypes.ListTemporaryAuthorizationCodesQuery
>;
export const syncTemporaryAuthorizationCodes = /* GraphQL */ `query SyncTemporaryAuthorizationCodes(
  $filter: ModelTemporaryAuthorizationCodeFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTemporaryAuthorizationCodes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      code
      userId
      expiresAt
      createdAt
      ttl
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTemporaryAuthorizationCodesQueryVariables,
  APITypes.SyncTemporaryAuthorizationCodesQuery
>;
export const listTemporaryAuthorizationCodesByUserId = /* GraphQL */ `query ListTemporaryAuthorizationCodesByUserId(
  $userId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemporaryAuthorizationCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listTemporaryAuthorizationCodesByUserId(
    userId: $userId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      code
      userId
      expiresAt
      createdAt
      ttl
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemporaryAuthorizationCodesByUserIdQueryVariables,
  APITypes.ListTemporaryAuthorizationCodesByUserIdQuery
>;
export const getLinkRegistry = /* GraphQL */ `query GetLinkRegistry($id: ID!) {
  getLinkRegistry(id: $id) {
    id
    propertyId
    action
    variables
    published
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLinkRegistryQueryVariables,
  APITypes.GetLinkRegistryQuery
>;
export const listLinkRegistries = /* GraphQL */ `query ListLinkRegistries(
  $id: ID
  $filter: ModelLinkRegistryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLinkRegistries(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      action
      variables
      published
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLinkRegistriesQueryVariables,
  APITypes.ListLinkRegistriesQuery
>;
export const syncLinkRegistries = /* GraphQL */ `query SyncLinkRegistries(
  $filter: ModelLinkRegistryFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncLinkRegistries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      action
      variables
      published
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncLinkRegistriesQueryVariables,
  APITypes.SyncLinkRegistriesQuery
>;
export const listLinkRegistriesByProperty = /* GraphQL */ `query ListLinkRegistriesByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLinkRegistryFilterInput
  $limit: Int
  $nextToken: String
) {
  listLinkRegistriesByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      action
      variables
      published
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLinkRegistriesByPropertyQueryVariables,
  APITypes.ListLinkRegistriesByPropertyQuery
>;
export const getExternalReportBranding = /* GraphQL */ `query GetExternalReportBranding($id: ID!) {
  getExternalReportBranding(id: $id) {
    id
    name
    logoKey
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExternalReportBrandingQueryVariables,
  APITypes.GetExternalReportBrandingQuery
>;
export const listExternalReportBrandings = /* GraphQL */ `query ListExternalReportBrandings(
  $id: ID
  $filter: ModelExternalReportBrandingFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listExternalReportBrandings(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      logoKey
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExternalReportBrandingsQueryVariables,
  APITypes.ListExternalReportBrandingsQuery
>;
export const syncExternalReportBrandings = /* GraphQL */ `query SyncExternalReportBrandings(
  $filter: ModelExternalReportBrandingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncExternalReportBrandings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      logoKey
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncExternalReportBrandingsQueryVariables,
  APITypes.SyncExternalReportBrandingsQuery
>;
export const listExternalReportBrandingsByCreatedBy = /* GraphQL */ `query ListExternalReportBrandingsByCreatedBy(
  $createdBy: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelExternalReportBrandingFilterInput
  $limit: Int
  $nextToken: String
) {
  listExternalReportBrandingsByCreatedBy(
    createdBy: $createdBy
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      logoKey
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExternalReportBrandingsByCreatedByQueryVariables,
  APITypes.ListExternalReportBrandingsByCreatedByQuery
>;
export const getMeeting = /* GraphQL */ `query GetMeeting($id: ID!) {
  getMeeting(id: $id) {
    id
    status
    data
    createdBy
    mediaPipelineId
    recordingKey
    recordingAttachmentId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMeetingQueryVariables,
  APITypes.GetMeetingQuery
>;
export const listMeetings = /* GraphQL */ `query ListMeetings(
  $id: ID
  $filter: ModelMeetingFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMeetings(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      status
      data
      createdBy
      mediaPipelineId
      recordingKey
      recordingAttachmentId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMeetingsQueryVariables,
  APITypes.ListMeetingsQuery
>;
export const syncMeetings = /* GraphQL */ `query SyncMeetings(
  $filter: ModelMeetingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncMeetings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      status
      data
      createdBy
      mediaPipelineId
      recordingKey
      recordingAttachmentId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncMeetingsQueryVariables,
  APITypes.SyncMeetingsQuery
>;
export const listMeetingsByMediaPipelineId = /* GraphQL */ `query ListMeetingsByMediaPipelineId(
  $mediaPipelineId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  listMeetingsByMediaPipelineId(
    mediaPipelineId: $mediaPipelineId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      data
      createdBy
      mediaPipelineId
      recordingKey
      recordingAttachmentId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMeetingsByMediaPipelineIdQueryVariables,
  APITypes.ListMeetingsByMediaPipelineIdQuery
>;
export const getAttendee = /* GraphQL */ `query GetAttendee($id: ID!) {
  getAttendee(id: $id) {
    id
    meetingId
    entityId
    name
    role
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAttendeeQueryVariables,
  APITypes.GetAttendeeQuery
>;
export const listAttendees = /* GraphQL */ `query ListAttendees(
  $id: ID
  $filter: ModelAttendeeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAttendees(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      meetingId
      entityId
      name
      role
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAttendeesQueryVariables,
  APITypes.ListAttendeesQuery
>;
export const syncAttendees = /* GraphQL */ `query SyncAttendees(
  $filter: ModelAttendeeFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAttendees(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      meetingId
      entityId
      name
      role
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAttendeesQueryVariables,
  APITypes.SyncAttendeesQuery
>;
export const listAttendeesByMeetingId = /* GraphQL */ `query ListAttendeesByMeetingId(
  $meetingId: ID!
  $entityId: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAttendeeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAttendeesByMeetingId(
    meetingId: $meetingId
    entityId: $entityId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      meetingId
      entityId
      name
      role
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAttendeesByMeetingIdQueryVariables,
  APITypes.ListAttendeesByMeetingIdQuery
>;
export const getCodeBuildJob = /* GraphQL */ `query GetCodeBuildJob($id: ID!) {
  getCodeBuildJob(id: $id) {
    id
    parentId
    projectName
    status
    artifactPath
    buildStartTime
    buildEndTime
    requestedBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCodeBuildJobQueryVariables,
  APITypes.GetCodeBuildJobQuery
>;
export const listCodeBuildJobs = /* GraphQL */ `query ListCodeBuildJobs(
  $id: ID
  $filter: ModelCodeBuildJobFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCodeBuildJobs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      parentId
      projectName
      status
      artifactPath
      buildStartTime
      buildEndTime
      requestedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCodeBuildJobsQueryVariables,
  APITypes.ListCodeBuildJobsQuery
>;
export const syncCodeBuildJobs = /* GraphQL */ `query SyncCodeBuildJobs(
  $filter: ModelCodeBuildJobFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCodeBuildJobs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      parentId
      projectName
      status
      artifactPath
      buildStartTime
      buildEndTime
      requestedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCodeBuildJobsQueryVariables,
  APITypes.SyncCodeBuildJobsQuery
>;
export const listCodeBuildJobsByParent = /* GraphQL */ `query ListCodeBuildJobsByParent(
  $parentId: String!
  $buildStartTime: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCodeBuildJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listCodeBuildJobsByParent(
    parentId: $parentId
    buildStartTime: $buildStartTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      parentId
      projectName
      status
      artifactPath
      buildStartTime
      buildEndTime
      requestedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCodeBuildJobsByParentQueryVariables,
  APITypes.ListCodeBuildJobsByParentQuery
>;
export const getResourceNotificationSetting = /* GraphQL */ `query GetResourceNotificationSetting(
  $resourceId: ID!
  $resourceType: NotificationResourceType!
  $notificationType: NotificationType!
) {
  getResourceNotificationSetting(
    resourceId: $resourceId
    resourceType: $resourceType
    notificationType: $notificationType
  ) {
    resourceId
    resourceType
    notificationType
    recipients {
      recipientId
      recipientIdType
      notificationChannels
      enabled
      __typename
    }
    enabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetResourceNotificationSettingQueryVariables,
  APITypes.GetResourceNotificationSettingQuery
>;
export const listResourceNotificationSettings = /* GraphQL */ `query ListResourceNotificationSettings(
  $resourceId: ID
  $resourceTypeNotificationType: ModelResourceNotificationSettingPrimaryCompositeKeyConditionInput
  $filter: ModelResourceNotificationSettingFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listResourceNotificationSettings(
    resourceId: $resourceId
    resourceTypeNotificationType: $resourceTypeNotificationType
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      resourceId
      resourceType
      notificationType
      recipients {
        recipientId
        recipientIdType
        notificationChannels
        enabled
        __typename
      }
      enabled
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceNotificationSettingsQueryVariables,
  APITypes.ListResourceNotificationSettingsQuery
>;
export const syncResourceNotificationSettings = /* GraphQL */ `query SyncResourceNotificationSettings(
  $filter: ModelResourceNotificationSettingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncResourceNotificationSettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      resourceId
      resourceType
      notificationType
      recipients {
        recipientId
        recipientIdType
        notificationChannels
        enabled
        __typename
      }
      enabled
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncResourceNotificationSettingsQueryVariables,
  APITypes.SyncResourceNotificationSettingsQuery
>;
export const getAssessmentSchedule = /* GraphQL */ `query GetAssessmentSchedule($id: ID!) {
  getAssessmentSchedule(id: $id) {
    id
    propertyId
    name
    description
    startDate
    endDate
    recurrence {
      type
      dailyRecurrence {
        interval
        __typename
      }
      weeklyRecurrence {
        interval
        daysOfWeek
        __typename
      }
      monthlyRecurrence {
        type
        interval
        dayOfMonth
        nthWeekDay {
          weekNumber
          day
          __typename
        }
        __typename
      }
      __typename
    }
    authorizedIdentifiers
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentScheduleQueryVariables,
  APITypes.GetAssessmentScheduleQuery
>;
export const listAssessmentSchedules = /* GraphQL */ `query ListAssessmentSchedules(
  $id: ID
  $filter: ModelAssessmentScheduleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAssessmentSchedules(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      name
      description
      startDate
      endDate
      recurrence {
        type
        dailyRecurrence {
          interval
          __typename
        }
        weeklyRecurrence {
          interval
          daysOfWeek
          __typename
        }
        monthlyRecurrence {
          type
          interval
          dayOfMonth
          nthWeekDay {
            weekNumber
            day
            __typename
          }
          __typename
        }
        __typename
      }
      authorizedIdentifiers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentSchedulesQueryVariables,
  APITypes.ListAssessmentSchedulesQuery
>;
export const syncAssessmentSchedules = /* GraphQL */ `query SyncAssessmentSchedules(
  $filter: ModelAssessmentScheduleFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAssessmentSchedules(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      name
      description
      startDate
      endDate
      recurrence {
        type
        dailyRecurrence {
          interval
          __typename
        }
        weeklyRecurrence {
          interval
          daysOfWeek
          __typename
        }
        monthlyRecurrence {
          type
          interval
          dayOfMonth
          nthWeekDay {
            weekNumber
            day
            __typename
          }
          __typename
        }
        __typename
      }
      authorizedIdentifiers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAssessmentSchedulesQueryVariables,
  APITypes.SyncAssessmentSchedulesQuery
>;
export const listAssessmentSchedulesByProperty = /* GraphQL */ `query ListAssessmentSchedulesByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAssessmentScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  listAssessmentSchedulesByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      name
      description
      startDate
      endDate
      recurrence {
        type
        dailyRecurrence {
          interval
          __typename
        }
        weeklyRecurrence {
          interval
          daysOfWeek
          __typename
        }
        monthlyRecurrence {
          type
          interval
          dayOfMonth
          nthWeekDay {
            weekNumber
            day
            __typename
          }
          __typename
        }
        __typename
      }
      authorizedIdentifiers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentSchedulesByPropertyQueryVariables,
  APITypes.ListAssessmentSchedulesByPropertyQuery
>;
export const getResourceAssessmentScheduleAssociation = /* GraphQL */ `query GetResourceAssessmentScheduleAssociation($id: ID!) {
  getResourceAssessmentScheduleAssociation(id: $id) {
    id
    assessmentScheduleId
    resourceId
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetResourceAssessmentScheduleAssociationQueryVariables,
  APITypes.GetResourceAssessmentScheduleAssociationQuery
>;
export const listResourceAssessmentScheduleAssociations = /* GraphQL */ `query ListResourceAssessmentScheduleAssociations(
  $id: ID
  $filter: ModelResourceAssessmentScheduleAssociationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listResourceAssessmentScheduleAssociations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      assessmentScheduleId
      resourceId
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceAssessmentScheduleAssociationsQueryVariables,
  APITypes.ListResourceAssessmentScheduleAssociationsQuery
>;
export const syncResourceAssessmentScheduleAssociations = /* GraphQL */ `query SyncResourceAssessmentScheduleAssociations(
  $filter: ModelResourceAssessmentScheduleAssociationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncResourceAssessmentScheduleAssociations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      assessmentScheduleId
      resourceId
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncResourceAssessmentScheduleAssociationsQueryVariables,
  APITypes.SyncResourceAssessmentScheduleAssociationsQuery
>;
export const listResourceAssessmentScheduleAssociationsByAssessmentSchedule = /* GraphQL */ `query ListResourceAssessmentScheduleAssociationsByAssessmentSchedule(
  $assessmentScheduleId: ID!
  $resourceId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelResourceAssessmentScheduleAssociationFilterInput
  $limit: Int
  $nextToken: String
) {
  listResourceAssessmentScheduleAssociationsByAssessmentSchedule(
    assessmentScheduleId: $assessmentScheduleId
    resourceId: $resourceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      assessmentScheduleId
      resourceId
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceAssessmentScheduleAssociationsByAssessmentScheduleQueryVariables,
  APITypes.ListResourceAssessmentScheduleAssociationsByAssessmentScheduleQuery
>;
export const listResourceAssessmentScheduleAssociationsByResource = /* GraphQL */ `query ListResourceAssessmentScheduleAssociationsByResource(
  $resourceId: ID!
  $resourceType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelResourceAssessmentScheduleAssociationFilterInput
  $limit: Int
  $nextToken: String
) {
  listResourceAssessmentScheduleAssociationsByResource(
    resourceId: $resourceId
    resourceType: $resourceType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      assessmentScheduleId
      resourceId
      resourceType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceAssessmentScheduleAssociationsByResourceQueryVariables,
  APITypes.ListResourceAssessmentScheduleAssociationsByResourceQuery
>;
export const getAssessment = /* GraphQL */ `query GetAssessment($id: ID!) {
  getAssessment(id: $id) {
    id
    scheduleId
    resourceId
    propertyId
    resourceType
    createdBy
    submittedBy {
      firstName
      lastName
      __typename
    }
    createdTime
    status
    issueIds
    tagIds
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentQueryVariables,
  APITypes.GetAssessmentQuery
>;
export const listAssessments = /* GraphQL */ `query ListAssessments(
  $id: ID
  $filter: ModelAssessmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAssessments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      scheduleId
      resourceId
      propertyId
      resourceType
      createdBy
      submittedBy {
        firstName
        lastName
        __typename
      }
      createdTime
      status
      issueIds
      tagIds
      description
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentsQueryVariables,
  APITypes.ListAssessmentsQuery
>;
export const syncAssessments = /* GraphQL */ `query SyncAssessments(
  $filter: ModelAssessmentFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAssessments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      scheduleId
      resourceId
      propertyId
      resourceType
      createdBy
      submittedBy {
        firstName
        lastName
        __typename
      }
      createdTime
      status
      issueIds
      tagIds
      description
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAssessmentsQueryVariables,
  APITypes.SyncAssessmentsQuery
>;
export const listAssessmentsBySchedule = /* GraphQL */ `query ListAssessmentsBySchedule(
  $scheduleId: ID!
  $createdTime: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAssessmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAssessmentsBySchedule(
    scheduleId: $scheduleId
    createdTime: $createdTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      scheduleId
      resourceId
      propertyId
      resourceType
      createdBy
      submittedBy {
        firstName
        lastName
        __typename
      }
      createdTime
      status
      issueIds
      tagIds
      description
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentsByScheduleQueryVariables,
  APITypes.ListAssessmentsByScheduleQuery
>;
export const listAssessmentsByResource = /* GraphQL */ `query ListAssessmentsByResource(
  $resourceId: ID!
  $resourceType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAssessmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAssessmentsByResource(
    resourceId: $resourceId
    resourceType: $resourceType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      scheduleId
      resourceId
      propertyId
      resourceType
      createdBy
      submittedBy {
        firstName
        lastName
        __typename
      }
      createdTime
      status
      issueIds
      tagIds
      description
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentsByResourceQueryVariables,
  APITypes.ListAssessmentsByResourceQuery
>;
export const listAssessmentsByProperty = /* GraphQL */ `query ListAssessmentsByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAssessmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAssessmentsByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      scheduleId
      resourceId
      propertyId
      resourceType
      createdBy
      submittedBy {
        firstName
        lastName
        __typename
      }
      createdTime
      status
      issueIds
      tagIds
      description
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentsByPropertyQueryVariables,
  APITypes.ListAssessmentsByPropertyQuery
>;
export const getContact = /* GraphQL */ `query GetContact($id: ID!) {
  getContact(id: $id) {
    id
    name
    email
    phoneNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetContactQueryVariables,
  APITypes.GetContactQuery
>;
export const listContacts = /* GraphQL */ `query ListContacts(
  $filter: ModelContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      email
      phoneNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListContactsQueryVariables,
  APITypes.ListContactsQuery
>;
export const syncContacts = /* GraphQL */ `query SyncContacts(
  $filter: ModelContactFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncContacts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      email
      phoneNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncContactsQueryVariables,
  APITypes.SyncContactsQuery
>;
export const getProperty3PIntegrationConfiguration = /* GraphQL */ `query GetProperty3PIntegrationConfiguration($id: ID!) {
  getProperty3PIntegrationConfiguration(id: $id) {
    id
    propertyId
    workflowEndpoint
    workflowName
    clientId
    clientSecret
    tokenUrl
    authorizeUrl
    scope
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProperty3PIntegrationConfigurationQueryVariables,
  APITypes.GetProperty3PIntegrationConfigurationQuery
>;
export const listProperty3PIntegrationConfigurations = /* GraphQL */ `query ListProperty3PIntegrationConfigurations(
  $id: ID
  $filter: ModelProperty3PIntegrationConfigurationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProperty3PIntegrationConfigurations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      propertyId
      workflowEndpoint
      workflowName
      clientId
      clientSecret
      tokenUrl
      authorizeUrl
      scope
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProperty3PIntegrationConfigurationsQueryVariables,
  APITypes.ListProperty3PIntegrationConfigurationsQuery
>;
export const syncProperty3PIntegrationConfigurations = /* GraphQL */ `query SyncProperty3PIntegrationConfigurations(
  $filter: ModelProperty3PIntegrationConfigurationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncProperty3PIntegrationConfigurations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyId
      workflowEndpoint
      workflowName
      clientId
      clientSecret
      tokenUrl
      authorizeUrl
      scope
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncProperty3PIntegrationConfigurationsQueryVariables,
  APITypes.SyncProperty3PIntegrationConfigurationsQuery
>;
export const listConfigurationsByProperty = /* GraphQL */ `query ListConfigurationsByProperty(
  $propertyId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProperty3PIntegrationConfigurationFilterInput
  $limit: Int
  $nextToken: String
) {
  listConfigurationsByProperty(
    propertyId: $propertyId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      propertyId
      workflowEndpoint
      workflowName
      clientId
      clientSecret
      tokenUrl
      authorizeUrl
      scope
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConfigurationsByPropertyQueryVariables,
  APITypes.ListConfigurationsByPropertyQuery
>;
export const getConversationState = /* GraphQL */ `query GetConversationState($id: ID!) {
  getConversationState(id: $id) {
    id
    attachments
    conversationType
    extractedDetails
    conversationStatus
    invokerId
    nextStep
    nextStepMessage
    userId
    externalConversationId
    phoneNumber
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConversationStateQueryVariables,
  APITypes.GetConversationStateQuery
>;
export const listConversationStates = /* GraphQL */ `query ListConversationStates(
  $id: ID
  $filter: ModelConversationStateFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listConversationStates(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      attachments
      conversationType
      extractedDetails
      conversationStatus
      invokerId
      nextStep
      nextStepMessage
      userId
      externalConversationId
      phoneNumber
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConversationStatesQueryVariables,
  APITypes.ListConversationStatesQuery
>;
export const syncConversationStates = /* GraphQL */ `query SyncConversationStates(
  $filter: ModelConversationStateFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncConversationStates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      attachments
      conversationType
      extractedDetails
      conversationStatus
      invokerId
      nextStep
      nextStepMessage
      userId
      externalConversationId
      phoneNumber
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncConversationStatesQueryVariables,
  APITypes.SyncConversationStatesQuery
>;
export const listConversationStatesByPhoneNumberAndStatus = /* GraphQL */ `query ListConversationStatesByPhoneNumberAndStatus(
  $phoneNumber: String!
  $conversationStatus: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelConversationStateFilterInput
  $limit: Int
  $nextToken: String
) {
  listConversationStatesByPhoneNumberAndStatus(
    phoneNumber: $phoneNumber
    conversationStatus: $conversationStatus
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      attachments
      conversationType
      extractedDetails
      conversationStatus
      invokerId
      nextStep
      nextStepMessage
      userId
      externalConversationId
      phoneNumber
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConversationStatesByPhoneNumberAndStatusQueryVariables,
  APITypes.ListConversationStatesByPhoneNumberAndStatusQuery
>;
export const getPolicyTemplateLink = /* GraphQL */ `query GetPolicyTemplateLink($id: ID!) {
  getPolicyTemplateLink(id: $id) {
    id
    templateId
    entityId
    entityType
    resourceId
    resourceType
    grantedBy
    grantedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPolicyTemplateLinkQueryVariables,
  APITypes.GetPolicyTemplateLinkQuery
>;
export const listPolicyTemplateLinks = /* GraphQL */ `query ListPolicyTemplateLinks(
  $id: ID
  $filter: ModelPolicyTemplateLinkFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPolicyTemplateLinks(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      templateId
      entityId
      entityType
      resourceId
      resourceType
      grantedBy
      grantedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPolicyTemplateLinksQueryVariables,
  APITypes.ListPolicyTemplateLinksQuery
>;
export const syncPolicyTemplateLinks = /* GraphQL */ `query SyncPolicyTemplateLinks(
  $filter: ModelPolicyTemplateLinkFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPolicyTemplateLinks(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      templateId
      entityId
      entityType
      resourceId
      resourceType
      grantedBy
      grantedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPolicyTemplateLinksQueryVariables,
  APITypes.SyncPolicyTemplateLinksQuery
>;
export const listPolicyTemplateLinksByEntityId = /* GraphQL */ `query ListPolicyTemplateLinksByEntityId(
  $entityId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPolicyTemplateLinkFilterInput
  $limit: Int
  $nextToken: String
) {
  listPolicyTemplateLinksByEntityId(
    entityId: $entityId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      templateId
      entityId
      entityType
      resourceId
      resourceType
      grantedBy
      grantedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPolicyTemplateLinksByEntityIdQueryVariables,
  APITypes.ListPolicyTemplateLinksByEntityIdQuery
>;
export const listPolicyTemplateLinksByResourceId = /* GraphQL */ `query ListPolicyTemplateLinksByResourceId(
  $resourceId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPolicyTemplateLinkFilterInput
  $limit: Int
  $nextToken: String
) {
  listPolicyTemplateLinksByResourceId(
    resourceId: $resourceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      templateId
      entityId
      entityType
      resourceId
      resourceType
      grantedBy
      grantedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPolicyTemplateLinksByResourceIdQueryVariables,
  APITypes.ListPolicyTemplateLinksByResourceIdQuery
>;
export const getGenerateIssuesFromImagesJob = /* GraphQL */ `query GetGenerateIssuesFromImagesJob($id: ID!) {
  getGenerateIssuesFromImagesJob(id: $id) {
    id
    extractedIssues
    status
    invokerId
    userId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGenerateIssuesFromImagesJobQueryVariables,
  APITypes.GetGenerateIssuesFromImagesJobQuery
>;
export const listGenerateIssuesFromImagesJobs = /* GraphQL */ `query ListGenerateIssuesFromImagesJobs(
  $id: ID
  $filter: ModelGenerateIssuesFromImagesJobFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listGenerateIssuesFromImagesJobs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      extractedIssues
      status
      invokerId
      userId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGenerateIssuesFromImagesJobsQueryVariables,
  APITypes.ListGenerateIssuesFromImagesJobsQuery
>;
export const syncGenerateIssuesFromImagesJobs = /* GraphQL */ `query SyncGenerateIssuesFromImagesJobs(
  $filter: ModelGenerateIssuesFromImagesJobFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncGenerateIssuesFromImagesJobs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      extractedIssues
      status
      invokerId
      userId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncGenerateIssuesFromImagesJobsQueryVariables,
  APITypes.SyncGenerateIssuesFromImagesJobsQuery
>;
export const getPreSignedUploadURL = /* GraphQL */ `query GetPreSignedUploadURL($input: GetPreSignedUploadURLRequest!) {
  getPreSignedUploadURL(input: $input)
}
` as GeneratedQuery<
  APITypes.GetPreSignedUploadURLQueryVariables,
  APITypes.GetPreSignedUploadURLQuery
>;
export const getPreSignedDownloadURL = /* GraphQL */ `query GetPreSignedDownloadURL($input: GetPreSignedDownloadRequest!) {
  getPreSignedDownloadURL(input: $input)
}
` as GeneratedQuery<
  APITypes.GetPreSignedDownloadURLQueryVariables,
  APITypes.GetPreSignedDownloadURLQuery
>;
export const getAccountClaimStatus = /* GraphQL */ `query GetAccountClaimStatus {
  getAccountClaimStatus {
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountClaimStatusQueryVariables,
  APITypes.GetAccountClaimStatusQuery
>;
export const handleConverseCommand = /* GraphQL */ `query HandleConverseCommand($input: HandleConverseCommandInput) {
  handleConverseCommand(input: $input)
}
` as GeneratedQuery<
  APITypes.HandleConverseCommandQueryVariables,
  APITypes.HandleConverseCommandQuery
>;
export const summarizeIssue = /* GraphQL */ `query SummarizeIssue($input: SummarizeIssueInput) {
  summarizeIssue(input: $input) {
    description
    workTypes {
      id
      groupId
      version
      name
      categoryName
      shortDescription
      longDescription
      dimensionType
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SummarizeIssueQueryVariables,
  APITypes.SummarizeIssueQuery
>;
export const customSearchUsers = /* GraphQL */ `query CustomSearchUsers($input: SearchUsersVariables!) {
  customSearchUsers(input: $input) {
    items {
      id
      name
      email
      phoneNumber
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomSearchUsersQueryVariables,
  APITypes.CustomSearchUsersQuery
>;
export const customSearchOrganizations = /* GraphQL */ `query CustomSearchOrganizations($input: SearchOrganizationsVariables!) {
  customSearchOrganizations(input: $input) {
    items {
      id
      legalName
      type
      canView
      canEdit
      canDelete
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomSearchOrganizationsQueryVariables,
  APITypes.CustomSearchOrganizationsQuery
>;
export const customSearchContacts = /* GraphQL */ `query CustomSearchContacts($input: SearchContactsVariables!) {
  customSearchContacts(input: $input) {
    items {
      id
      name
      email
      phoneNumber
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomSearchContactsQueryVariables,
  APITypes.CustomSearchContactsQuery
>;
export const getFormConfiguration = /* GraphQL */ `query GetFormConfiguration($id: ID) {
  getFormConfiguration(id: $id) {
    ... on PlainFormConfiguration {
      linkRegistry {
        id
        propertyId
        action
        variables
        published
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
    }
    ... on AssessmentFormConfiguration {
      linkRegistry {
        id
        propertyId
        action
        variables
        published
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      branding {
        id
        name
        logoKey
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      locationId
      locationName
      propertyId
      authorizedIdentifiers
    }
    ... on IssueSubmissionFormConfiguration {
      linkRegistry {
        id
        propertyId
        action
        variables
        published
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      branding {
        id
        name
        logoKey
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      locationId
      locationName
      propertyId
    }
  }
}
` as GeneratedQuery<
  APITypes.GetFormConfigurationQueryVariables,
  APITypes.GetFormConfigurationQuery
>;
export const listFormConfigurationsByProperty = /* GraphQL */ `query ListFormConfigurationsByProperty(
  $propertyId: ID!
  $actions: [LinkAction!]
  $nextToken: String
) {
  listFormConfigurationsByProperty(
    propertyId: $propertyId
    actions: $actions
    nextToken: $nextToken
  ) {
    items
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFormConfigurationsByPropertyQueryVariables,
  APITypes.ListFormConfigurationsByPropertyQuery
>;
export const listAssessmentSchedulesByAssessors = /* GraphQL */ `query ListAssessmentSchedulesByAssessors(
  $assessors: [String]!
  $nextToken: String
) {
  listAssessmentSchedulesByAssessors(
    assessors: $assessors
    nextToken: $nextToken
  ) {
    items {
      scheduleName
      locationNames
      scheduleDate
      assessors
      status
      overdue
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentSchedulesByAssessorsQueryVariables,
  APITypes.ListAssessmentSchedulesByAssessorsQuery
>;
export const getSubscriptionDetails = /* GraphQL */ `query GetSubscriptionDetails {
  getSubscriptionDetails {
    plan
    meteringLimit
    meteringUsage
    trialEnd
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionDetailsQueryVariables,
  APITypes.GetSubscriptionDetailsQuery
>;
export const filterImages = /* GraphQL */ `query FilterImages($input: FilterImagesInput) {
  filterImages(input: $input) {
    validImages
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FilterImagesQueryVariables,
  APITypes.FilterImagesQuery
>;
export const classifyIssues = /* GraphQL */ `query ClassifyIssues($input: ClassifyIssuesInput) {
  classifyIssues(input: $input) {
    issues {
      note
      images
      attachmentLocation
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClassifyIssuesQueryVariables,
  APITypes.ClassifyIssuesQuery
>;
